<template>
  <div>

    <el-container>

      <div style="position: relative;width: auto;height: auto" v-if="this.RecordFlag == 0">
        <table style="position: relative; width: auto;height: auto; margin: 0 auto;float: left" v-if="this.RecordFlag == 0">
          <tr>
            <td v-if="this.RecordFlag == 0">
              <el-button style="" type="primary" plain size="small" @click="Audit(scopedata)" v-if="this.RecordFlag == 0">
                <!--                  <el-button type="primary" size="small" @click="Audit(scopedata)" v-if="this.RecordFlag == 0">-->
                <span v-if="this.RecordFlag == 0">提交审核</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <!--                  <el-button style="margin-left: -650px" type="primary" size="small" @click="Rollback(scopedata)" v-if="this.RecordFlag == 0">-->
              <el-button style="margin-left: 10px" type="primary" plain size="small" @click="Rollback(scopedata)" v-if="this.RecordFlag == 0">
                <span>回退</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" type="primary" plain size="small" @click="showlc(scopedata)" v-if="this.RecordFlag == 0">
                <span v-if="this.RecordFlag == 0">查流程</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportDetails(scopedata)" v-if="this.RecordFlag == 0">报告详情
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportQuery(scopedata)" v-if="this.RecordFlag == 0">记录查询
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="NoticeQuery(scopedata)" v-if="this.RecordFlag == 0">备忘录
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoQuery(scopedata)" v-if="this.RecordFlag == 0">检测视频
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="PictureQuery(scopedata)" v-if="this.RecordFlag == 0">检测图片
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoUpload(scopedata)" v-if="this.RecordFlag == 0">上传视频
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="showQuery" v-if="this.RecordFlag == 0">查询条件
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 0">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="flushPage" v-if="this.RecordFlag == 0">刷新
              </el-button>
            </td>
          </tr>
        </table>
      </div>

      <div style="position: relative;width: auto;height: auto" v-if="this.RecordFlag == 5">
        <table style="position: relative; width: auto;height: auto; margin: 0 auto;float: left" v-if="this.RecordFlag == 5">
          <tr>
            <td v-if="this.RecordFlag == 5">
              <el-button style="" type="primary" plain size="small" @click="OpenShsj(scopedata)" v-if="this.RecordFlag == 5">
                <span v-if="this.RecordFlag == 5 ">审核</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <!--                  <el-button style="margin-left: -650px" type="primary" size="small" @click="Rollback(scopedata)" v-if="this.RecordFlag == 0">-->
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="Qualified(scopedata)" v-show="this.RecordFlag == 5">退回
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" type="primary" plain size="small" @click="showlc(scopedata)" v-if="this.RecordFlag == 5">
                <span v-if="this.RecordFlag == 5">查流程</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportDetails(scopedata)" v-if="this.RecordFlag == 5">报告详情
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportQuery(scopedata)" v-if="this.RecordFlag == 5">记录查询
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="NoticeQuery(scopedata)" v-if="this.RecordFlag == 5">备忘录
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoQuery(scopedata)" v-if="this.RecordFlag == 5">检测视频
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="PictureQuery(scopedata)" v-if="this.RecordFlag == 5">检测图片
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoUpload(scopedata)" v-if="this.RecordFlag == 5">上传视频
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="showQuery" v-if="this.RecordFlag == 5">查询条件
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 5">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="flushPage" v-if="this.RecordFlag == 5">刷新
              </el-button>
            </td>
          </tr>
        </table>
      </div>

      <div style="position: relative;width: auto;height: auto" v-if="this.RecordFlag == 2">
        <table style="position: relative; width: auto;height: auto; margin: 0 auto;float: left" v-if="this.RecordFlag == 2">
          <tr>
            <td v-if="this.RecordFlag == 2">
              <el-button style="" type="primary" plain size="small" @click="OpenPzsj(scopedata)" v-if="this.RecordFlag == 2">
                <span v-if="this.RecordFlag == 2 ">批准</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <!--                  <el-button style="margin-left: -650px" type="primary" size="small" @click="Rollback(scopedata)" v-if="this.RecordFlag == 0">-->
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="Qualified(scopedata)" v-show="this.RecordFlag == 2">退回
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" type="primary" plain size="small" @click="showlc(scopedata)" v-if="this.RecordFlag == 2">
                <span v-if="this.RecordFlag == 2">查流程</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportDetails(scopedata)" v-if="this.RecordFlag == 2">报告详情
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportQuery(scopedata)" v-if="this.RecordFlag == 2">记录查询
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="NoticeQuery(scopedata)" v-if="this.RecordFlag == 2">备忘录
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoQuery(scopedata)" v-if="this.RecordFlag == 2">检测视频
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="PictureQuery(scopedata)" v-if="this.RecordFlag == 2">检测图片
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoUpload(scopedata)" v-if="this.RecordFlag == 2">上传视频
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="showQuery" v-if="this.RecordFlag == 2">查询条件
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 2">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="flushPage" v-if="this.RecordFlag == 2">刷新
              </el-button>
            </td>
          </tr>
        </table>
      </div>

      <div style="position: relative;width: auto;height: auto" v-if="this.RecordFlag == 3">
        <table style="position: relative; width: auto;height: auto; margin: 0 auto;float: left" v-if="this.RecordFlag == 3">
          <tr>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" type="primary" plain size="small" @click="showlc(scopedata)" v-if="this.RecordFlag == 3">
                <span v-if="this.RecordFlag == 3">查流程</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small"  type="primary" plain @click="ReportDetails(scopedata)" v-if="this.RecordFlag == 3">报告详情
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportQuery(scopedata)" v-if="this.RecordFlag == 3">记录查询
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="NoticeQuery(scopedata)" v-if="this.RecordFlag == 3">备忘录
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoQuery(scopedata)" v-if="this.RecordFlag == 3">检测视频
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="PictureQuery(scopedata)" v-if="this.RecordFlag == 3">检测图片
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoUpload(scopedata)" v-if="this.RecordFlag == 3" :disabled="gaiz">
                <span v-if="this.RecordFlag == 3">上传视频</span>
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="showQuery" v-if="this.RecordFlag == 3">查询条件
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain @click="flushPage" v-if="this.RecordFlag == 3">刷新
              </el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <!--              <el-button style="margin-left: 10px" size="small" type="primary" v-if="this.RecordFlag == 3"-->
              <!--                         @click="handleExport('导出','#exportTab',{ raw: true })">导出当前页面数据</el-button>-->
              <el-button style="margin-left: 10px" size="small" type="primary" plain v-if="this.RecordFlag == 3"  @click="exportDate()">导出数据</el-button>
            </td>
            <td v-if="this.RecordFlag == 3">
              <el-button style="margin-left: 10px" size="small" type="primary" plain v-if="this.RecordFlag == 3 && (this.authList.indexOf('17') !== -1)"  @click="tuihui(scopedata)">退回未上传</el-button>
            </td>
          </tr>
        </table>
      </div>

      <div style="position: relative;width: auto;height: auto" v-if="this.RecordFlag == 4">
        <tr>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" type="primary" plain size="small" @click="Audit(scopedata)" v-if="this.RecordFlag == 4">
              <span v-if="this.RecordFlag == 4">上传</span>
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="Qualified(scopedata)" v-show="this.RecordFlag == 4">退回
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary"  plain @click="Audit3(scopedata)" v-if="this.RecordFlag == 4">新规上传
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportDetails(scopedata)" v-if="this.RecordFlag == 4">报告详情
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="ReportQuery(scopedata)" v-if="this.RecordFlag == 4">记录查询
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="NoticeQuery(scopedata)" v-if="this.RecordFlag == 4">备忘录
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="VideoQuery(scopedata)" v-if="this.RecordFlag == 4">检测视频
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="PictureQuery(scopedata)" v-if="this.RecordFlag == 4">检测图片
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary"  plain @click="VideoUpload(scopedata)" v-if="this.RecordFlag == 4">
              <span v-if="this.RecordFlag == 4">上传视频</span>
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <!--              <el-button type="primary" size="small" @click="ToSeal(scopedata)" v-if="scopedata.recStatus == 3">-->
            <el-button style="margin-left: 10px" type="primary" size="small" plain @click="ToSeal(scopedata)" v-if="this.RecordFlag == 4">
              <!--                <span v-if="scopedata.recStatus == 3">盖章</span>-->
              <span v-if="this.RecordFlag == 4">盖章</span>
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="showQuery" v-if="this.RecordFlag == 4">查询条件
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="flushPage" v-if="this.RecordFlag == 4">刷新
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="Audit2(scopedata,0)" v-if="this.RecordFlag == 4">重新上传
            </el-button>
          </td>
          <td v-if="this.RecordFlag == 4">
            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="Audit2(scopedata,1)" v-if="this.RecordFlag == 4">改1重传
            </el-button>
          </td>
        </tr>
      </div>

      <el-main style="position: relative">
        <el-table
            v-loading="loadang"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            :data="tableData"
            style="width: 100%;height:50vh;"
            border
            ref='table'
            :cell-class-name="tableRowClassName"
            @cell-click="handleCellClick"
            highlight-current-row
        >
<!--     fixed="left"     <el-table-column prop="recId" label="#" min-width="8%" sortable/>-->
          <el-table-column prop="recStatus"  min-width="120" max-width="200" label="状态">
            <template v-slot="scope">
              <span v-if="scope.row.recStatus == 0">初检</span>
              <span v-if="scope.row.recStatus == 1">重新编辑</span>
              <span v-if="scope.row.recStatus == 2">已审核</span>
              <span v-if="scope.row.recStatus == 3">已批准</span>
              <span v-if="scope.row.recStatus == 4">已上传</span>
              <span v-if="scope.row.recStatus == 5">编制</span>
            </template>
          </el-table-column>
          <el-table-column prop="liftNum" min-width="120" max-width="200" label="产品编号">
          </el-table-column>
          <el-table-column prop="unit" min-width="220" max-width="300" label="使用单位">
          </el-table-column>
          <el-table-column prop="loginNum" min-width="120" max-width="200" label="登记证编号">
          </el-table-column>
<!--          <el-table-column prop="recResult" min-width="8%" label="检测结果">-->
<!--            <template v-slot="scope">-->
<!--              <span v-if="scope.row.recResult == 0">合格</span>-->
<!--              <span v-if="scope.row.recResult == 1">不合格</span>-->
<!--              <span v-if="scope.row.recResult == 2">待审核</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="areaName" min-width="120" max-width="200" label="区域名称"></el-table-column>
          <el-table-column prop="userAlias" min-width="120" max-width="200" label="检测人员"></el-table-column>
          <el-table-column show-overflow-tooltip prop="recDate" min-width="120" max-width="200" sortable label="检测时间">
            <template v-slot="scope">
              <span>{{ this.formatDate(scope.row.recDate, "yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="plaitDate" min-width="120" max-width="200" sortable label="提交审核时间" v-if="this.RecordFlag == 5">
            <template v-slot="scope">
              <span>{{ this.formatDate(scope.row.plaitDate, "yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="processDate" min-width="120" max-width="200" sortable label="审核时间" v-if="this.RecordFlag == 2">
            <template v-slot="scope">
              <span>{{ this.formatDate(scope.row.processDate, "yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="ratifyData" min-width="120" max-width="200" sortable label="批准时间" v-if="this.RecordFlag == 4 || this.RecordFlag == 3">
            <template v-slot="scope">
              <span>{{ this.formatDate(scope.row.ratifyData, "yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="uploadDate" min-width="120" max-width="200" sortable label="上传时间" v-if="this.RecordFlag == 4 || this.RecordFlag == 3">
            <template v-slot="scope">
              <span>{{ this.formatDate(scope.row.uploadDate, "yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rejectDetail" min-width="120" max-width="200" label="退回原因"></el-table-column>
          <el-table-column   prop="videoUrl" min-width="120" max-width="200"   label="检测视频是否存在">
            <template v-slot="scope">
              <span>{{  scope.row.videoUrl!=null && scope.row.videoUrl!=""?'存在':'不存在'  }}</span>
            </template>
          </el-table-column>
          <el-table-column   prop="superviseCode" min-width="120" max-width="200" fixed="right"  label="监察识别码">
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div class="demonstration" style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage"
                         v-model:page-size="pageSize"
                         :page-sizes="[20, 40,60]"
                         :small="small"
                         :background="background"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         :prev="prev"
                         :pager="pager"
                         :next="next"
                         :jumper="jumper"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
        <!--                :disabled="disabled"-->
      </el-footer>
    </el-container>
    <el-dialog v-model="dialogFormVisible" title="查看检测记录" width="60%">
      <div align="left" style="margin-left: 20px">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="创建人">{{ theOne.createBy }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{
              this.formatDate(theOne.createDate, "yyyy-MM-dd hh:mm:ss")
            }}
          </el-descriptions-item>
          <el-descriptions-item label="制造单位">{{ theOne.DeviceList[0].createUnit }}</el-descriptions-item>
          <el-descriptions-item label="制造日期">{{
              this.formatDate(theOne.DeviceList[0].createDate, "yyyy-MM-dd hh:mm:ss")
            }}
          </el-descriptions-item>
          <el-descriptions-item label="使用单位">{{ theOne.areaName }}</el-descriptions-item>
          <el-descriptions-item label="设备使用地点">{{ theOne.sceneName }}</el-descriptions-item>
          <el-descriptions-item label="设备品种">{{ theOne.DeviceList[0].liftType }}</el-descriptions-item>
          <el-descriptions-item label="检测日期">{{
              this.formatDate(theOne.recDate, "yyyy-MM-dd hh:mm:ss")
            }}
          </el-descriptions-item>
          <el-descriptions-item label="检测模板">{{ theOne.templateName === '' ? '暂无数据' : theOne.templateName }}
            --＞{{ theOne.maxtermName === '' ? '暂无数据' : theOne.maxtermName }}--＞{{ theOne.sceneName === '' ? '暂无数据' : theOne.sceneName }}
          </el-descriptions-item>
        </el-descriptions>

        <p style="font-weight: bold;  ">检测评语：</p>
        <p>{{ theOne.comment }}</p>

        <!--        <p style="font-weight: bold;   ">图片和视频：</p>
                <img :src="imgUrl" style="width: 100px; height: 100px">-->
      </div>
    </el-dialog>
    <el-dialog v-model="dialogResultVisible" title="退回提示" width="40%">
      <el-form :model="formResult" ref="formResult" :rules="rules" status-icon label-width="120px">

        <el-form-item label="退回去向" prop="recStatus">
          <el-radio-group v-model="formResult.recStatus">
<!--            <el-radio-button v-if="RecordFlag == 2"  :label="5">&nbsp;&nbsp;编&nbsp;&nbsp;&nbsp;&nbsp;制&nbsp;&nbsp;</el-radio-button>-->
            <el-radio-button v-if="RecordFlag != 4" :label="0">重新编辑</el-radio-button>
            <el-radio-button v-if="RecordFlag == 4" :label="5">审核</el-radio-button>
            <el-radio-button  v-if="RecordFlag == 4" :label="2">批准</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="退回原因" v-if="RecordFlag != 4" prop="rejectDetail">
          <el-input v-model="formResult.rejectDetail"
                    show-word-limit clearable
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    style="width: 300px"
                    type="textarea" maxlength="200"></el-input>
        </el-form-item>

      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button style="margin-top: -40px;" @click="dialogResultVisible = false">关闭</el-button>
          <el-button style="margin-top: -40px;margin-right: 50px"  v-if="RecordFlag != 4" type="primary" @click="formResultSave('formResult')"
          >确认</el-button >
          <el-button style="margin-top: -40px;margin-right: 50px"  v-if="RecordFlag == 4" type="primary" @click="formResultSave2('formResult')"
          >确认</el-button >
        </span>
      </template>
    </el-dialog>
    <el-dialog v-model="tp" title="检测图片" :lock-scroll="false">
      <!--          <div class="scroll-container" >-->
      <!--          <div class="demo-image__lazy" style="display: flex; flex-direction: row;flex-wrap: wrap; justify-content:space-around;width: auto;height: auto">-->
      <!--            <el-image v-for="url in urls" :key="url" :src="url" lazy ></el-image>-->
      <!--          </div>-->
      <!--          </div>-->

      <div class="demo-image__lazy">
        <el-image v-for="url in urls" :key="url" :src="url" lazy></el-image>
      </div>


    </el-dialog>
    <!--    <el-input hidden>{{ currentPathName }}</el-input>-->
  </div>

  <el-dialog title="审批记录" v-model="timeline" >
    <div id="app" style="margin-left: 150px">
      <div class="items">
        <div v-for="(item,index) in items" :key="index" :style="{color:item.color}" class="item">
          <div  class="point" :style="{background:item.color}"></div>
          <div v-if="index+1 != items.length" class="line" :style="{background:lineColor(item.color,index)}" ></div>
          <div class="item-right" style="font-size: 13px">
            <div class="person">操&nbsp;作&nbsp;人:&nbsp;{{item.person}}</div>
            <div class="content" style="margin-top: 5px">状态变更:&nbsp;{{item.content}}</div>
            <!--            <div class="content">状态变更:&nbsp;{{// item.shenhe}}</div>-->
            <div class="time" style="margin-top: 5px">操作时间:&nbsp;{{item.time}}</div>
            <!--            <div class="time">操作备注:&nbsp;{{item.beizhu}}</div>-->
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog title="审批记录" v-model="timeline2" >
    <div id="app2" style="margin-left: 150px">
      <div class="items">
        <div v-for="(item,index) in items2" :key="index" :style="{color:item.color}" class="item">
          <div  class="point" :style="{background:item.color}"></div>
          <div v-if="index+1 != items2.length" class="line" :style="{background:lineColor(item.color,index)}" ></div>
          <div class="item-right" style="font-size: 13px">
            <div class="person">操&nbsp;作&nbsp;人:&nbsp;{{item.person}}</div>
            <div class="content" style="margin-top: 5px">状态变更:&nbsp;{{item.content}}</div>
            <!--            <div class="content">状态变更:&nbsp;{{// item.shenhe}}</div>-->
            <div class="time" style="margin-top: 5px">操作时间:&nbsp;{{item.time}}</div>
            <!--            <div class="time">操作备注:&nbsp;{{item.beizhu}}</div>-->
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog title="审批记录" v-model="timeline3" >
    <div id="app3" style="margin-left: 150px">
      <div class="items">
        <div v-for="(item,index) in items3" :key="index" :style="{color:item.color}" class="item">
          <div  class="point" :style="{background:item.color}"></div>
          <div v-if="index+1 != items3.length" class="line" :style="{background:lineColor(item.color,index)}" ></div>
          <div class="item-right" style="font-size: 13px">
            <div class="person">操&nbsp;作&nbsp;人:&nbsp;{{item.person}}</div>
            <div class="content" style="margin-top: 5px">状态变更:&nbsp;{{item.content}}</div>
            <!--            <div class="content" style="margin-top: 5px">变更备注:&nbsp;{{item.beizhu}}</div>-->
            <!--            <div class="content">状态变更:&nbsp;{{// item.shenhe}}</div>-->
            <div class="time" style="margin-top: 5px">操作时间:&nbsp;{{item.time}}</div>
            <!--            <div class="time">操作备注:&nbsp;{{item.beizhu}}</div>-->
          </div>
        </div>
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="tcts" title="上传视频" :lock-scroll="false"  width="50%" draggable :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="form" ref="form" :rules="rules" status-icon label-width="160px">
      <el-form-item label="" status-icon label-width="160px">
        <el-upload
            class="upload-demo"
            :action="this.ip+'/detection/saveVideo'"
            multiple
            :limit="1"
            :show-file-list="true"
            :on-success="uploadSuccess"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePreview"
            :on-progress="onProgressTest"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-exceed="handleExceed"
            :file-list="fileList"
            ref="upload"
        >
<!--          2023.11.27，添加上传的进度调控，组件进度条卡在100%-->
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>

      </el-form-item>
    </el-form>
    <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: -50px" @click="tcts = false">关闭</el-button>
                        <el-button style="margin-top: -50px" type="primary" @click="onSubmit(scopedata)" :disabled="disabled">确定</el-button>
                      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="cxtj" title="查询条件" :lock-scroll="false"  width="80%" draggable :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="formchecked" label-position="left" ref="formRef"
             size="medium" style="width: auto; height:auto; margin: 0 auto; position: relative">
      <table style="position: relative; width: auto; height: auto">
        <tr>
          <td><!--检测时间大于等于-->
            <el-form-item style="float: left" label="" prop="checked1" size="mini">
              <el-checkbox label="检测时间大于等于" :disabled="!checkedA"
                           v-model="formchecked.checked1"></el-checkbox>
              <el-date-picker
                  v-model="ThisForm.f1_startTimeOutweigh"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  format="YYYY/MM/DD HH:mm:ss"
                  type="datetime"
                  :disabled="!formchecked.checked1"
                  placeholder="选择日期时间"
                  style="width: 200px;">
              </el-date-picker>

            </el-form-item>
          </td>
          <td> <!--工单ID-->
            <el-form-item style="float: left" label="" prop="checked8" size="mini" class="formItem">

              <el-checkbox label="工单ID" :disabled="!checkedB"
                           v-model="formchecked.checked8"></el-checkbox>
              <el-input v-model="ThisForm.orderId" :disabled="!formchecked.checked8"
                        onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 150px"></el-input>

            </el-form-item>
          </td>


          <td><!--检测人员-->
            <el-form-item style="float: left" label="" prop="checked7" size="mini" class="formItem">
              <el-checkbox label="检测人员" :disabled="!checkedB"
                           v-model="formchecked.checked7"></el-checkbox>
              <el-input v-model="ThisForm.userAlias" :disabled="!formchecked.checked7"
                        style="width: 150px"></el-input>


            </el-form-item>
          </td>

          <td>  <!--物业-->
            <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="使用单位" :disabled="!checkedB"
                           v-model="formchecked.checked3"></el-checkbox>
              <el-input v-model="ThisForm.unit" :disabled="!formchecked.checked3"
                        style="width: 150px;"></el-input>

            </el-form-item>
          </td>


        </tr>
        <tr>
          <td> <!--检测时间小于等于-->
            <el-form-item style="float: left" label="" prop="checked2" size="mini" class="formItem">

              <el-checkbox label="检测时间小于等于" :disabled="!checkedA"
                           v-model="formchecked.checked2"></el-checkbox>
              <el-date-picker
                  v-model="ThisForm.f2_startTimeLessthen"
                  :disabled="!formchecked.checked2"
                  type="datetime"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  format="YYYY/MM/DD HH:mm:ss"
                  placeholder="选择日期时间"
                  style="width: 200px">
              </el-date-picker>

            </el-form-item>
          </td>
          <td> <!--电梯ID-->
            <el-form-item style="float: left" label="" prop="checked9" size="mini" class="formItem">
              <el-checkbox label="电梯ID" :disabled="!checkedB"
                           v-model="formchecked.checked9"></el-checkbox>
              <el-input v-model.number="ThisForm.liftId" :disabled="!formchecked.checked9"
                        onkeyup="value=value.replace(/^(0+)|[^\dT#]+/g,'')" style="width: 150px"></el-input>

            </el-form-item>
          </td>

          <td>  <!--物业-->
            <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="物业" :disabled="!checkedB"
                           v-model="formchecked.checked6"></el-checkbox>
              <el-input v-model="ThisForm.areaName" :disabled="!formchecked.checked6"
                        style="width: 150px; margin-left: 27px"></el-input>

            </el-form-item>
          </td>

          <td>  <!--物业-->
            <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="产品编号" :disabled="!checkedB"
                           v-model="formchecked.checked4"></el-checkbox>
              <el-input v-model="ThisForm.liftNum" :disabled="!formchecked.checked4"
                        style="width: 150px;"></el-input>

            </el-form-item>
          </td>
        </tr>

        <tr>
          <td>  <!--物业-->
            <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="使用登记证编号" :disabled="!checkedB"
                           v-model="formchecked.checked5"></el-checkbox>
              <el-input v-model="ThisForm.loginNum" :disabled="!formchecked.checked5"
                        style="width: 190px; margin-left: 15px; "></el-input>

            </el-form-item>
          </td>

          <td>  <!--物业-->
            <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="注册代码" :disabled="!checkedB"
                           v-model="formchecked.checked10"></el-checkbox>
              <el-input v-model="ThisForm.lifeRegistCode" :disabled="!formchecked.checked10"
                        style="width: 135px; "></el-input>

            </el-form-item>
          </td>

          <td>  <!--物业-->
            <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="使用单位代码" :disabled="!checkedB"
                           v-model="formchecked.checked11"></el-checkbox>
              <el-input v-model="ThisForm.unitCode" :disabled="!formchecked.checked11"
                        style="width: 100px;  "></el-input>

            </el-form-item>
          </td>

          <td>  <!--物业-->
            <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="监察识别码" :disabled="!checkedB"
                           v-model="formchecked.checked12"></el-checkbox>
              <el-input v-model="ThisForm.superviseCode" :disabled="!formchecked.checked12"
                        style="width: 150px;"></el-input>

            </el-form-item>
          </td>

          <el-form-item style="float: left" size="medium">
            <div style="margin: 0 auto;">
<!--              <el-button type="primary" @click="submitForm('formchecked','ThisForm')" style="margin-left: 10px">查询-->
<!--              </el-button>-->
<!--              <el-button type="primary" @click="flushPage">刷新</el-button>-->
            </div>
          </el-form-item>
        </tr>
        <tr>
          <td>  <!--物业-->
            <el-form-item v-if="this.RecordFlag == 3" style="float: left" label="" prop="checked6" size="mini" class="formItem">
              <el-checkbox label="状态" :disabled="!checkedB"
                           v-model="formchecked.checked13"></el-checkbox>
              <!--              <el-input v-model="ThisForm.recStatus" :disabled="!formchecked.checked13"-->
              <!--                        style="width: 150px;"></el-input>-->
              <el-select v-model="ThisForm.recStatus"  clearable  :disabled="!formchecked.checked13">
                <el-option label="已批准" value="3"></el-option>
                <el-option label="已上传" value="4"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>

      </table>
    </el-form>
    <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: -50px" @click="cxtj = false">关闭</el-button>
                        <el-button style="margin-top: -50px" type="primary" @click="submitForm('formchecked','ThisForm',0)" :disabled="disabled">确定</el-button>
                      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="shsj" title="选择审核时间" :lock-scroll="false"  width="50%" draggable :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="sh_form" label-position="left" ref="formRef"
             size="medium" style="width: auto; height:auto; margin: 0 auto; position: relative">
      <table style="position: relative; width: auto; height: auto">
        <tr>
          <td><!--检测时间大于等于-->
            <el-form-item style="float: left" label="审核时间"  size="mini">

              <el-date-picker
                  v-model="ThisForm.new_shsj"
                  value-format="YYYY-MM-DD"
                  format="YYYY/MM/DD"
                  type="date"
                  placeholder="选择日期"
                  style="width: 200px;">
              </el-date-picker>

            </el-form-item>
          </td>
        </tr>

      </table>
    </el-form>
    <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: -50px" @click="shsj = false">关闭</el-button>
                        <el-button style="margin-top: -50px" type="primary" @click="Audit(scopedata)" >确定</el-button>
                      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="pzsj" title="选择批准时间" :lock-scroll="false"  width="50%" draggable :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="pz_form" label-position="left" ref="formRef"
             size="medium" style="width: auto; height:auto; margin: 0 auto; position: relative">
      <table style="position: relative; width: auto; height: auto">
        <tr>
          <td><!--检测时间大于等于-->
            <el-form-item style="float: left" label="批准时间"  size="mini">

              <el-date-picker
                  v-model="ThisForm.new_pzsj"
                  value-format="YYYY-MM-DD"
                  format="YYYY/MM/DD"
                  type="date"
                  placeholder="选择日期"
                  style="width: 200px;">
              </el-date-picker>

            </el-form-item>
          </td>
        </tr>

      </table>
    </el-form>
    <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: -50px" @click="pzsj = false">关闭</el-button>
                        <el-button style="margin-top: -50px" type="primary" @click="Audit(scopedata)" >确定</el-button>
                      </span>
    </template>
  </el-dialog>
</template>

<script>
import request from "@/util/request";
import table2Excel from 'js-table2excel' // 引入  js-table2excel
// import request1 from "@/util/request1";
import moment from "moment";
import {ElLoading} from "element-plus";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Record",
  data() {
    return {
      scopedata: {},
      tep:-1,//用于判断调用了哪个状态的方法，0：编制的load, 1:审核的load ,2:批准的load,3:查询的load,4:上传的load ,5:combSelect1, 6:combSelect2,7:combSelect,8:combSelect3
      reload:0,//判断重新将currentPage 设置为 1； 0：currentPage=1
      ip:localStorage.getItem("ip"),
      urls: [],
      vuepdf:'',
      items:[
        {
          content:'',
          person:'',
          time:'',
          // color:'blue',
          beizhu: ''
        }
      ],
      items2: [
        {
          content:'',
          person:'',
          time:'',
          // color:'blue',
          beizhu: ''
        },
        {
          content:'',
          person:'',
          time:'',
          // color:'green',
          beizhu: ''
        },
      ],
      items3: [
        {
          content:'',
          person:'',
          time:'',
          // color:'blue',
          beizhu: ''
        },
        {
          content:'',
          person:'',
          time:'',
          // color:'green',
          beizhu: ''
        },
        {
          content:'',
          person:'',
          time:'',
          // color:'green',
          beizhu: ''
        },
      ],
      // select:null,
      form: {},
      options: [],//评分方案的类型列表
      option: {},//评分方案的类型对象
      formResult: {
        recStatus:0,
      }, //驳回表单
      dialogFormVisible: false,
      dialogResultVisible: false, //不合格dialog控制
      tp: false, //检测图片dialog控制
      timeline: false,
      timeline2: false,
      timeline3: false,
      currentPage: 1,
      pageSize: 20,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [], //未分页的数据
      tableData: [],//渲染到页面上的数据

      disabledAudit: false,
      disabledQualified: false,
      theOne: {}, //查看的单条数据
      RecordFlag: this.$route.query.RecordFlag,

      //表单收集的数据
      ThisForm: {
        f1_startTimeOutweigh: this.formatDate(this.getbeforetime(), "yyyy-MM-dd hh:mm:ss"),
        f2_startTimeLessthen: this.formatDate(this.getaftertime(), "yyyy-MM-dd hh:mm:ss"),
        new_shsj: this.formatDate(this.shtime(), "yyyy-MM-dd"),
        new_pzsj: this.formatDate(this.shtime(), "yyyy-MM-dd"),
      },
      //多选框
      formchecked: {
        checked1: true,
        checked2: true,
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        checked7: false,
        checked8: false,
        checked9: false,
        checked10: false,
        checked11: false,
        checked12: false,
        checked13: false,
      },
      sh_form: {},
      pz_form: {},
      checkedA: true,
      checkedB: true,
      ticketPush: {},

      //图片路径
      imgUrl: require('/src/assets/logo.png'),

      //驳回输入验证
      rules:{
        rejectDetail:[
          {required: true, min: 1, max: 200, message: '模板名不能为空,长度： 1 ~ 200', trigger: 'blur'},
        ]
      },
      authList:[],//用户的权限
      loadang: true,
      gaiz: false,
      tcts: false,
      cxtj: false,
      shsj: false,
      pzsj: false,
      videoUploadUrl: '',
      fileList: [{
        // name: '',
        // url: ''
      }],
      exportConfig: [ // 导出Excel表格配置
        {
          title: '状态',
          key: 'recStatus',
          type: 'text'
        },
        {
          title: '产品编号',
          key: 'liftNum',
          type: 'text'
        },
        {
          title: '使用单位',
          key: 'unit',
          type: 'text'
        },
        {
          title: '登记证编号',
          key: 'loginNum',
          type: 'text'
        },{
          title: '区域名称',
          key: 'areaName',
          type: 'text'
        },
        {
          title: '检测人员',
          key: 'userAlias',
          type: 'text'
        },
        {
          title: '检测时间',
          key: 'recDate',
          type: 'text'
        },
        {
          title: '提交审核时间',
          key: 'plaitDate',
          type: 'text'
        },
        {
          title: '审核时间',
          key: 'processDate',
          type: 'text'
        },
        {
          title: '批准时间',
          key: 'ratifyData',
          type: 'text'
        },{
          title: '上传时间',
          key: 'uploadDate',
          type: 'text'
        },
        {
          title: '退回原因',
          key: 'rejectDetail',
          type: 'text'
        },
        {
          title: '检测视频是否存在',
          key: 'videoUrl',
          type: 'text'
        },
        {
          title: '监察识别码',
          key: 'superviseCode',
          type: 'text'
        },
      ],
      formatColumns:[ // 导出特殊字段处理
        {
          prop: 'recStatus',
          option: {
            '0': '初检',
            '1': '重新编辑',
            '2': '已审核',
            '3': '已批准',
            '4': '已上传',
            '5': '编制'
          },
        },
      ],
    }
  },
  created() {

    this.load(0);
    this.getList();
  },
  computed: {
    currentPathName: function () {

      return this.$store.getters.getCurrentPathName;
    },

  },

  watch: {

    curren() {
      console.log("进入监听")
      if (this.currentPathName() === "质检记录审核") {
        console.log("变化了")
      }
    }
  },

  methods: {
    tuihui(row){//退回未上传
      let  name = sessionStorage.getItem("userName");
      if(name==null||name ==""||name ==undefined){
        this.$message({
          type: 'warning',
          message: '登录超时请重新登录!'
        });
        this.$router.push({path: '/login', query: {}});
        return;
      }
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      }else {
        if(row.recStatus != 4 ) {
          this.$message({
            type: 'warning',
            message: '请选择已上传记录!'
          });
          return;
        }
        let tip = '是否确认将记录退回未上传?'
        this.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          request.get('/Record/backunupload', {
            params:{
              recId: row.recId,
              userName: localStorage.getItem("userName"),
            }
          }).then(res => {
            if (res === 0) { //已退回已上传，直接刷新
              this.$message({
                type: 'success',
                message: '数据已操作!'
              });
              this.ticket = [];
              this.load();
            }
            if (res > 0) {
              this.tocreatReport(row, 5); //重新生成报告，5：标识退回未上传状态
            }
            if (res <0) {
              this.$message({
                type: 'error',
                message: '退回已上传失败!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      }
    },
    exportDate(){
      let arr =JSON.parse(JSON.stringify(this.ticket)) ;
      for (let i = 0; i < this.ticket.length; i++) {
        arr[i].recDate = this.formatDate(this.ticket[i].recDate, "yyyy-MM-dd");
        arr[i].plaitDate = this.formatDate(this.ticket[i].plaitDate, "yyyy-MM-dd");
        arr[i].processDate = this.formatDate(this.ticket[i].processDate, "yyyy-MM-dd");
        arr[i].ratifyData = this.formatDate(this.ticket[i].ratifyData, "yyyy-MM-dd");
        arr[i].uploadDate = this.formatDate(this.ticket[i].uploadDate, "yyyy-MM-dd");
        if(this.ticket[i].videoUrl!=null && this.ticket[i].videoUrl!=""){
          arr[i].videoUrl ='存在';
        }else arr[i].videoUrl ='不存在';
      }
      let list = JSON.stringify(arr);
      list = this.formatExportData(JSON.parse(list));
      // table2Excel(state.exportConfig, list, '导出数据') state.exportConfig导出表格配置，list导出数据列表，“导出数据”：导出文件名称
      console.log(list)
      let date = this.formatDate(new Date(), "yyyy-MM-dd");
      table2Excel(this.exportConfig, list, '导出数据_'+date)
    },
    formatExportData(list) {
      // 处理特殊字段
      /*
        比如：你请求的数据中的age返回的是1或者2，其1代表“男”2代表“女”
        导出表格时，总不能以1和2的方式展示，此方法用于处理特殊字段
      */
      list.forEach((item) => {
        this.formatColumns.forEach((i) => {
          item[i.prop] = i.option[item[i.prop]]
        })
        for (let key in item) {
          if (!item[key] && item[key] == null) {
            item[key] = ""
          }
        }
      });
      return list
    },
    handleCellClick(row) {
      console.log(row)
      if (row.recStatus == 4) {
        this.gaiz = true
      } else {
        this.gaiz = false
      }
      this.scopedata = row;
      // console.log(column)
      // console.log(cell)
      // console.log(event)
    },
    tableRowClassName({rowIndex}) {
      // console.log(row)
      // console.log(rowIndex)
      if (rowIndex === 1) {
        // console.log(row)
        // console.log(rowIndex)
        return 'warning-row';
      } else if (rowIndex === 3) {
        // console.log(row)
        // console.log(rowIndex)
        return 'success-row';
      }
      return '';
    },
    createRecord(row, id) {
      let vm = this;
      let map = {
        recId: row.recId,
      };
      //生成记录
      request.post('/detection/reportquery', map).then(res => {
        console.log(res);
        console.log(res.data);

        if (res.code === '0') {
          switch (id) {
            case 1:
              this.$message({
                type: 'success',
                message: '审核成功!'
              });

              break;
            case 2:
              this.$message({
                type: 'success',
                message: '批准成功!'
              });
              break;
            case 3:
              this.$message({
                type: 'success',
                message: '驳回成功!'
              });
              break;
            case 4:
              this.$message({
                type: 'success',
                message: '驳回成功!'
              });
              break;
            case 5:
              this.$message({
                type: 'success',
                message: '退回未上传成功!'
              });
              break;
          }
          vm.ticket = [];
          vm.load()
        }else {
          this.$message({
            type: 'error',
            message: '生成记录失败!'
          });
        }
      })

    },
    tocreatReport(row, id) {
      let map = {
        recId: row.recId,
      };
      let vm = this;
      const loading = ElLoading.service({
        lock: true,
        text: '执行中...',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout(() => {
        loading.close();
        return 11;
      }, 2000) ;
      //生成报告
      request.post('/detection/report', map).then(res => {
        console.log(res);
        console.log(res.data);
        if(res.code==='0'){
          vm.createRecord(res.data, id);
          clearTimeout(11);
        }else {
          this.$message({
            type: 'error',
            message: '生成报告失败!'
          });
        }
      })

    },
    showgzs(row){
      // let map = {
      //   recId: row.recId,
      //   signature:""
      // };
      this.$confirm('是否确定打开?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      // request.post('/detection/notice', map).then(res => {
        console.log("打开告知书详情");
        // let data = JSON.parse(res);
        //  console.log(data+"----");
        // console.log(res.filepath);
        // this.$router.push({path:'RecordPdf', query:{recordpdf:res.filepath}})
        window.open(row.noticeUrl);

        // window.open(res.data.noticeUrl);
        // window.open(res.filepath);
      // })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    lineColor(color,index){
      let i;
      this.items.forEach((item,j)=>{
        if(item.color){
          i = j
        }
      })
      if(color&&i!=index){
        return color
      }
    },
    // 表格查询
    //提交数据到后台
    submitForm(formchecked, ThisForm,reload) {
      console.log(formchecked, ThisForm);
      console.log(this.ThisForm);
      console.log(this.mergeSQL());
      if (this.reload === reload) {
        this.currentPage = 1;
      }
      if (this.RecordFlag == 0) {
        if (!this.formchecked.checked1 && !this.formchecked.checked2 && !this.formchecked.checked6 && !this.formchecked.checked7 && !this.formchecked.checked8 && !this.formchecked.checked9 && !this.formchecked.checked3 && !this.formchecked.checked4 && !this.formchecked.checked5 && !this.formchecked.checked10 && !this.formchecked.checked11 && !this.formchecked.checked12) {
          this.tableData = [];
          this.total = 0
          this.loadang = false
          this.cxtj = false
          console.log("没勾选值")
          this.$message({
            type: 'error',
            message: '请勾选要查询的内容!'
          });
        }
        else if (this.formchecked.checked1 || this.formchecked.checked2 || this.formchecked.checked6 || this.formchecked.checked7 || this.formchecked.checked8 || this.formchecked.checked9 || this.formchecked.checked3 || this.formchecked.checked4 || this.formchecked.checked5 || this.formchecked.checked10 || this.formchecked.checked11 || this.formchecked.checked12) {
          request.post("/RecDetView/combSelect11",
                  {"sql": this.mergeSQL(), "RecordFlag": this.RecordFlag, userName: sessionStorage.getItem("userName")
                    ,roleId:sessionStorage.getItem("roleId"),
                    areaId:sessionStorage.getItem("areaId"),
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    status:"0,1"
                  }).then(res => {
            console.log(res)
            this.tep = 5;//标识使用了该方法
            this.ticket = [];
            this.loadang = false
            this.cxtj = false
            console.log(this.ticket)
            this.tableData =[];
            this.tableData = res.data.list;
            this.total =res.data.total;
            // this.ticket = res;
            // this.total = this.ticket.length
            this.loadang = false
            this.cxtj = false
            // this.getPageInfo()
          })
          if ((this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh == '') || (this.formchecked.checked8 && this.ThisForm.orderId == undefined || this.ThisForm.orderId == '') || (this.formchecked.checked6 && this.ThisForm.areaName == undefined) || (this.formchecked.checked6 && this.ThisForm.areaName == '') || (this.formchecked.checked7 && this.ThisForm.userAlias == undefined) || (this.formchecked.checked7 && this.ThisForm.userAlias == '') || (this.formchecked.checked9 && this.ThisForm.liftId == undefined) || (this.formchecked.checked9 && this.ThisForm.liftId == '') || (this.formchecked.checked3 && this.ThisForm.unit == undefined) || (this.formchecked.checked3 && this.ThisForm.unit == '') || (this.formchecked.checked4 && this.ThisForm.liftNum == undefined) || (this.formchecked.checked4 && this.ThisForm.liftNum == '') || (this.formchecked.checked5 && this.ThisForm.loginNum == undefined) || (this.formchecked.checked5 && this.ThisForm.loginNum == '') || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == undefined) || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') || (this.formchecked.checked11 && this.ThisForm.unitCode == undefined) || (this.formchecked.checked11 && this.ThisForm.unitCode == '') || (this.formchecked.checked12 && this.ThisForm.superviseCode == undefined) || (this.formchecked.checked12 && this.ThisForm.superviseCode == '')) {
            this.tableData = [];
            this.loadang = false
            this.cxtj = false
            this.$message({
              type: 'error',
              message: '请输入要查询的内容!'
            });
          }
        }
      }
      if (this.RecordFlag == 3) {
        if (!this.formchecked.checked1 && !this.formchecked.checked2 && !this.formchecked.checked6 && !this.formchecked.checked7 && !this.formchecked.checked8 && !this.formchecked.checked9 && !this.formchecked.checked3 && !this.formchecked.checked4 && !this.formchecked.checked5 && !this.formchecked.checked10 && !this.formchecked.checked11 && !this.formchecked.checked12 && !this.formchecked.checked13) {
          this.tableData = [];
          this.total = 0
          this.loadang = false
          this.cxtj = false
          console.log("没勾选值")
          this.$message({
            type: 'error',
            message: '请勾选要查询的内容!'
          });
        }
        else if (this.formchecked.checked1 || this.formchecked.checked2 || this.formchecked.checked6  || this.formchecked.checked7  || this.formchecked.checked8  || this.formchecked.checked9 || this.formchecked.checked3 || this.formchecked.checked4 || this.formchecked.checked5 || this.formchecked.checked10 || this.formchecked.checked11 || this.formchecked.checked12|| this.formchecked.checked13 ) {
          request.post("/RecDetView/combSelect11",
                  {"sql": this.mergeSQL(), "RecordFlag": this.RecordFlag, userName: sessionStorage.getItem("userName")
                    ,roleId:sessionStorage.getItem("roleId"),
                    areaId:sessionStorage.getItem("areaId"),
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    status:"3,4" //检测查询
                  }).then(res => {
            console.log(res)
            this.ticket = [];
            this.loadang = false
            this.cxtj = false
            this.tep =6;
            console.log(this.ticket)
            this.tableData =[];
            this.tableData = res.data.list;
            this.total =res.data.total;
            // this.ticket = res;
            // this.total = this.ticket.length
            this.loadang = false
            this.cxtj = false
            // this.getPageInfo()
          })
          if ((this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh == '') || (this.formchecked.checked8 && this.ThisForm.orderId == undefined || this.ThisForm.orderId == '') || (this.formchecked.checked6 && this.ThisForm.areaName == undefined) || (this.formchecked.checked6 && this.ThisForm.areaName == '') || (this.formchecked.checked7 && this.ThisForm.userAlias == undefined) ||
                  (this.formchecked.checked7 && this.ThisForm.userAlias == '') || (this.formchecked.checked9 && this.ThisForm.liftId == undefined) || (this.formchecked.checked9 && this.ThisForm.liftId == '') || (this.formchecked.checked3 && this.ThisForm.unit == undefined)
                  || (this.formchecked.checked3 && this.ThisForm.unit == '') || (this.formchecked.checked4 && this.ThisForm.liftNum == undefined) || (this.formchecked.checked4 && this.ThisForm.liftNum == '') || (this.formchecked.checked5 && this.ThisForm.loginNum == undefined) || (this.formchecked.checked5 && this.ThisForm.loginNum == '') || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == undefined) || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') || (this.formchecked.checked11 && this.ThisForm.unitCode == undefined)
                  || (this.formchecked.checked11 && this.ThisForm.unitCode == '') ||
                  (this.formchecked.checked12 && this.ThisForm.superviseCode == undefined) || (this.formchecked.checked12 && this.ThisForm.superviseCode == '') || (this.formchecked.checked13 && (this.ThisForm.recStatus == ''||this.ThisForm.recStatus == undefined))) {
            this.tableData = [];
            this.loadang = false
            this.cxtj = false
            this.$message({
              type: 'error',
              message: '请输入要查询的内容!'
            });
          }
        }
      }
      if (this.RecordFlag == 5 || this.RecordFlag == 2) {
        if (!this.formchecked.checked1 && !this.formchecked.checked2 && !this.formchecked.checked6 && !this.formchecked.checked7 && !this.formchecked.checked8 && !this.formchecked.checked9 && !this.formchecked.checked3 && !this.formchecked.checked4 && !this.formchecked.checked5 && !this.formchecked.checked10 && !this.formchecked.checked11 && !this.formchecked.checked12 ) {
          this.tableData = [];
          this.total = 0
          this.loadang = false
          this.cxtj = false
          console.log("没勾选值")
          this.$message({
            type: 'error',
            message: '请勾选要查询的内容!'
          });
        }
        else if (this.formchecked.checked1 || this.formchecked.checked2 || this.formchecked.checked6  || this.formchecked.checked7  || this.formchecked.checked8  || this.formchecked.checked9 || this.formchecked.checked3 || this.formchecked.checked4 || this.formchecked.checked5 || this.formchecked.checked10 || this.formchecked.checked11 || this.formchecked.checked12 ) {
          request.post("/RecDetView/combSelect22",
                  {"sql": this.mergeSQL(), "RecordFlag": this.RecordFlag, userName: sessionStorage.getItem("userName")
                    ,roleId:sessionStorage.getItem("roleId"),
                    areaId:sessionStorage.getItem("areaId"),
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    // sign:"0"
                  }).then(res => {
            console.log(res)
            this.ticket = [];
            this.loadang = false
            this.cxtj = false
            console.log(this.ticket)
            this.tep =7;
            this.tableData =[];
            this.tableData = res.data.list;
            this.total =res.data.total;
            // this.ticket = res;
            // this.total = this.ticket.length
            this.loadang = false
            this.cxtj = false
            // this.getPageInfo()
          })
          if ((this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh == '') || (this.formchecked.checked8 && this.ThisForm.orderId == undefined || this.ThisForm.orderId == '') || (this.formchecked.checked6 && this.ThisForm.areaName == undefined) || (this.formchecked.checked6 && this.ThisForm.areaName == '') || (this.formchecked.checked7 && this.ThisForm.userAlias == undefined) || (this.formchecked.checked7 && this.ThisForm.userAlias == '') || (this.formchecked.checked9 && this.ThisForm.liftId == undefined) || (this.formchecked.checked9 && this.ThisForm.liftId == '') || (this.formchecked.checked3 && this.ThisForm.unit == undefined) || (this.formchecked.checked3 && this.ThisForm.unit == '') || (this.formchecked.checked4 && this.ThisForm.liftNum == undefined) || (this.formchecked.checked4 && this.ThisForm.liftNum == '') || (this.formchecked.checked5 && this.ThisForm.loginNum == undefined) || (this.formchecked.checked5 && this.ThisForm.loginNum == '') || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == undefined) || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') || (this.formchecked.checked11 && this.ThisForm.unitCode == undefined) || (this.formchecked.checked11 && this.ThisForm.unitCode == '') || (this.formchecked.checked12 && this.ThisForm.superviseCode == undefined) || (this.formchecked.checked12 && this.ThisForm.superviseCode == '')) {
            this.tableData = [];
            this.loadang = false
            this.cxtj = false
            this.$message({
              type: 'error',
              message: '请输入要查询的内容!'
            });
          }
        }
      }
      if (this.RecordFlag == 4) {
        if (!this.formchecked.checked1 && !this.formchecked.checked2 && !this.formchecked.checked6 && !this.formchecked.checked7 && !this.formchecked.checked8 && !this.formchecked.checked9 && !this.formchecked.checked3 && !this.formchecked.checked4 && !this.formchecked.checked5 && !this.formchecked.checked10 && !this.formchecked.checked11 && !this.formchecked.checked12) {
          this.tableData = [];
          this.total = 0
          this.loadang = false
          this.cxtj = false
          console.log("没勾选值")
          this.$message({
            type: 'error',
            message: '请勾选要查询的内容!'
          });
        }
        else if (this.formchecked.checked1 || this.formchecked.checked2 || this.formchecked.checked6  || this.formchecked.checked7  || this.formchecked.checked8  || this.formchecked.checked9 || this.formchecked.checked3 || this.formchecked.checked4 || this.formchecked.checked5 || this.formchecked.checked10 || this.formchecked.checked11 || this.formchecked.checked12 ) {
          request.post("/RecDetView/combSelect22",
                  {"sql": this.mergeSQL(), "RecordFlag": 3, userName: sessionStorage.getItem("userName")
                    ,roleId:sessionStorage.getItem("roleId"),
                    areaId:sessionStorage.getItem("areaId"),
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    // sign:"1" //标识
                  }).then(res => {
            console.log(res)
            this.ticket = [];
            this.loadang = false
            this.cxtj = false
            console.log(this.ticket)
            this.tep =8;
            this.tableData =[];
            this.tableData = res.data.list;
            this.total =res.data.total;
            // this.ticket = res;
            // this.total = this.ticket.length
            this.loadang = false
            this.cxtj = false
            // this.getPageInfo()
          })
          if ((this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh == '') || (this.formchecked.checked8 && this.ThisForm.orderId == undefined || this.ThisForm.orderId == '') || (this.formchecked.checked6 && this.ThisForm.areaName == undefined) || (this.formchecked.checked6 && this.ThisForm.areaName == '') || (this.formchecked.checked7 && this.ThisForm.userAlias == undefined) || (this.formchecked.checked7 && this.ThisForm.userAlias == '') || (this.formchecked.checked9 && this.ThisForm.liftId == undefined) || (this.formchecked.checked9 && this.ThisForm.liftId == '') || (this.formchecked.checked3 && this.ThisForm.unit == undefined) || (this.formchecked.checked3 && this.ThisForm.unit == '') || (this.formchecked.checked4 && this.ThisForm.liftNum == undefined) || (this.formchecked.checked4 && this.ThisForm.liftNum == '') || (this.formchecked.checked5 && this.ThisForm.loginNum == undefined) || (this.formchecked.checked5 && this.ThisForm.loginNum == '') || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == undefined) || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') || (this.formchecked.checked11 && this.ThisForm.unitCode == undefined) || (this.formchecked.checked11 && this.ThisForm.unitCode == '') || (this.formchecked.checked12 && this.ThisForm.superviseCode == undefined) || (this.formchecked.checked12 && this.ThisForm.superviseCode == '')) {
            this.tableData = [];
            this.loadang = false
            this.cxtj = false
            this.$message({
              type: 'error',
              message: '请输入要查询的内容!'
            });
          }
        }
      }
    },

    //刷新页面
    flushPage(){
      // this.load();
      this.$nextTick(() => {
        this.$refs.table.doLayout()
        console.log("刷新成功")
        location.reload();
        // this.$router.push({path:'record', query:{RecordFlag : 5}})
      })
    },

    //拼接sql
    mergeSQL() {
      var SQL = '';
      var SQL1 = " and recDate >= ",
          SQL2 = " and recDate <= ",
          SQL3 = " and unit like ",
          SQL4 = " and liftNum like ",
          SQL5 = " and loginNum like ",
          SQL6 = " and areaName like ",
          SQL7 = " and userAlias like ",
          SQL8 = " and orderId = ",
          SQL9 = " and liftId = ",
          SQL10 = " and lifeRegistCode like ",
          SQL11 = " and unitCode like ",
              SQL12 = " and superviseCode like ",
              SQL13 = " and recStatus = ";
      if (this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh !== '' && this.ThisForm.f1_startTimeOutweigh !== undefined) {

        // eslint-disable-next-line no-useless-escape
        SQL1 += "'" + moment(this.ThisForm.f1_startTimeOutweigh).format('YYYY-MM-DD HH:mm:ss') + "'";
      } else {
        SQL1 = '';
      }
      if (this.formchecked.checked2 && this.ThisForm.f2_startTimeLessthen !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL2 += "'" + moment(this.ThisForm.f2_startTimeLessthen).format('YYYY-MM-DD HH:mm:ss') + "'";
        //console.log(SQL2)
      } else {
        SQL2 = '';
      }
      if (this.formchecked.checked3 && this.ThisForm.unit !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL3 += "'" + "%" +this.ThisForm.unit + "%" +"'";
        //console.log(SQL2)
      } else if (this.formchecked.checked3 && this.ThisForm.unit == '') {
        SQL3 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL3 = '';
      }
      if (this.formchecked.checked4 && this.ThisForm.liftNum !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL4 += "'" + "%" +this.ThisForm.liftNum + "%" +"'";
        //console.log(SQL2)
      } else if (this.formchecked.checked4 && this.ThisForm.liftNum == '') {
        SQL4 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL4 = '';
      }
      if (this.formchecked.checked5 && this.ThisForm.loginNum !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL5 += "'" + "%" +this.ThisForm.loginNum + "%" +"'";
        //console.log(SQL2)
      } else if (this.formchecked.checked5 && this.ThisForm.loginNum == '') {
        SQL5 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL5 = '';
      }
      if (this.formchecked.checked6 && this.ThisForm.areaName !== '') {
        SQL6 += "'" + "%" +this.ThisForm.areaName + "%" +"'";
      }  else if (this.formchecked.checked6 && this.ThisForm.areaName == '') {
        SQL6 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL6 = '';
      }
      if (this.formchecked.checked7 && this.ThisForm.userAlias !== '') {
        SQL7 += "'" + "%" + this.ThisForm.userAlias + "%" + "'";
      } else if (this.formchecked.checked7 && this.ThisForm.userAlias == '') {
        SQL7 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL7 = '';
      }
      if (this.formchecked.checked8 && this.ThisForm.orderId !== '') {
        SQL8 += this.ThisForm.orderId;
      } else {
        SQL8 = '';
      }
      if (this.formchecked.checked9 && this.ThisForm.liftId !== '') {
        SQL9 += this.ThisForm.liftId;
      } else {
        SQL9 = '';
      }
      if (this.formchecked.checked10 && this.ThisForm.lifeRegistCode !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL10 += "'" + "%" +this.ThisForm.lifeRegistCode + "%" +"'";
        //console.log(SQL2)
      } else if (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') {
        SQL10 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL10 = '';
      }
      if (this.formchecked.checked11 && this.ThisForm.unitCode !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL11 += "'" + "%" +this.ThisForm.unitCode + "%" +"'";
        //console.log(SQL2)
      } else if (this.formchecked.checked11 && this.ThisForm.unitCode == '') {
        SQL11 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL11 = '';
      }
      if (this.formchecked.checked12 && this.ThisForm.superviseCode !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL12 += "'" + "%" +this.ThisForm.superviseCode + "%" +"'";
        //console.log(SQL2)
      } else if (this.formchecked.checked12 && this.ThisForm.superviseCode == '') {
        SQL12 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL12 = '';
      }
      if (this.formchecked.checked13 && this.ThisForm.recStatus !== '') {
        SQL13 += this.ThisForm.recStatus;
      } else {
        SQL13 = '';
      }
      SQL += SQL1 + SQL2 + SQL3 + SQL4 + SQL5 + SQL6 + SQL7 + SQL8 + SQL9 + SQL10 + SQL11 + SQL12+ SQL13;
      return SQL + '      order by updateDate asc';
    },

    // 获取时间
    getbeforetime() {
      //获取到的时间 (中国标准时间)
      var d = new Date((new Date().getTime() - 24 * 60 * 60 * 1000));
      // 处理成的格式
      var time = d.getFullYear()-1 + '-' + (d.getMonth() + 1) + '-' + (d.getDate())
          + ' 00:00:01';
      return new Date(time);
    },
    getaftertime() {
      var d = new Date();
      var time = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
          + ' 23:59:59';
      return new Date(time);
    },

    shtime() {
      var d = new Date();
      var time = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
      return new Date(time);
    },


    //添加按钮点击事件
    add() {
      request.get('/Record/AddData').then(res => {
        console.log(res)
        this.load();
      })

    },

    //查看详情
    Detailed(row) {
      console.log(row)
      request.get('/Record/ShowResult?maxtermId=' + row.maxtermId + '&templateId=' + row.templateId + '&liftId=' + row.liftId).then(res => {
        console.log(res)
        console.log(res.maxtermName)
        console.log(res.templateName)
        console.log(res.DeviceList)
        this.dialogFormVisible = true
        this.theOne = row
        this.theOne.maxtermName = res.maxtermName
        this.theOne.templateName = res.templateName
        this.theOne.DeviceList = res.DeviceList
        console.log(this.theOne)
        console.log(this.theOne.DeviceList[0].liftType)
      })
    },

    //回退按钮
    Rollback(row){
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        this.$confirm('是否确认回退?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          request.get('/Record/Rollback', {
            params: {
              recId: row.recId,
            }
          }).then(res => {
            if (res === 1 || res === 0) {
              this.ticket = [];
              this.load()
              this.$message({
                type: 'success',
                message: '已回退到初检!'
              });
            } else {
              this.$message({
                type: 'error',
                message: '回退到初检失败!'
              });
            }
            // if (res == 0){
            //   this.$message({
            //     type: 'success',
            //     message: '已回退到初检!'
            //   });
            //
            // }
            // if (res == 1){
            //   this.$confirm('无此条数据', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '关闭',
            //     type: 'warning'
            //   }).then(() => {
            //
            //   })
            // }
            // if (res == 2){
            //   this.$confirm('无此条数据', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '关闭',
            //     type: 'warning'
            //   }).then(() => {
            //
            //   })
            // }
            // if (res == 3){
            //   this.$confirm('无此条数据', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '关闭',
            //     type: 'warning'
            //   }).then(() => {
            //
            //   })
            // }
            // if (res == 4){
            //   this.$confirm('无此条数据', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '关闭',
            //     type: 'warning'
            //   }).then(() => {
            //
            //   })
            // }
            // if (res == 5){
            //   this.$confirm('中无此条数据', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '关闭',
            //     type: 'warning'
            //   }).then(() => {
            //
            //   })
            // }
            this.ticket = [];
            this.load()
            // this.submitForm(this.formchecked, this.ThisForm)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },

    //审核批准
    Audit(row) {
      if (row.recStatus == 0 && row.recResult == 1){
        this.$confirm('该条记录还未进行重新编辑！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
        }).then(() => {
          this.$message({
            type: 'info',
            message: '请前往APP端进行重新编辑'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '请前往APP端进行重新编辑'
          });
        });
        return;
      }
      let tip = '是否确认审核检测记录?'
      if (this.RecordFlag == 0 || this.RecordFlag == 1) {
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认提交审核检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            if (row.recStatus == 0 || row.recStatus == 1) {
              // let map = {
              //   recId: row.recId,
              //   submitNum: row.submitNum + 1
              // }
              if (row.plaitDate == null || row.plaitDate == "") {
                request.get('/Record/WeaveUpdate', {
                  params:{
                    recId: row.recId,
                    submitNum: row.submitNum + 1,
                    userName: sessionStorage.getItem("userName")
                  }
                }).then(res => {
                  console.log("she审核按钮："+res)
                  // this.submitForm(this.formchecked, this.ThisForm)
                  this.ticket = [];
                  this.load()
                  // this.tableData = []
                  // this.total = 0
                  if (res > 0) {
                    this.$message({
                      type: 'success',
                      message: '提交成功!'
                    });

                    console.log(res)
                  }
                })
              }
              else {
                // let map2 = {
                //   recId: row.recId,
                //   submitNum: row.submitNum + 1,
                //   plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
                // }
                console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
                request.get('/Record/WeaveUpdate2', {
                  params:{
                    recId: row.recId,
                    submitNum: row.submitNum + 1,
                    plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
                  }
                }).then(res => {
                  console.log("she审核按钮："+res)
                  // this.submitForm()
                  // this.tableData = []
                  // this.total = 0
                  this.load()
                  if (res > 0) {
                    this.$message({
                      type: 'success',
                      message: '提交成功!'
                    });
                    console.log(res)
                    console.log(res.plaitHistory)
                  }
                })
                // }
              }
            }
            // if (row.recStatus == 5) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   auditNum: row.auditNum + 1
            //   // }
            //   if (row.processDate == null || row.processDate == "") {
            //     request.get('/Record/AuditUpdate', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         userName: sessionStorage.getItem("userName")
            //       }
            //     }).then(res => {
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   } else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   auditNum: row.auditNum + 1,
            //     //   processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     request.get('/Record/AuditUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   }
            // }
            // if (row.recStatus == 2) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   ratifyNum: row.ratifyNum + 1
            //   // }
            //   request.get('/Record/ApproveUpdate', {
            //     params:{
            //       recId: row.recId,
            //       ratifyNum: row.ratifyNum + 1,
            //       userName: sessionStorage.getItem("userName")
            //     }
            //   }).then(res => {
            //     // this.submitForm(this.formchecked, this.ThisForm)
            //     if (res === 0) { //已批准，直接刷新
            //       this.$message({
            //         type: 'success',
            //         message: '数据已操作!'
            //       });
            //       this.ticket = [];
            //       this.load();
            //     }
            //     if (res > 0) {
            //       this.tocreatReport(row, 2); //重新生成报告
            //     }
            //     if (res <0) {
            //       this.$message({
            //         type: 'error',
            //         message: '批准失败!'
            //       });
            //     }
            //     // this.ticket = []
            //     // this.load()
            //     // if (res > 0) {
            //     //   this.$message({
            //     //     type: 'success',
            //     //     message: '批准成功!'
            //     //   });
            //     // }
            //   })
            // }
            // if (row.recStatus == 3) {
            //   // console.log(row)
            //   console.log(row.liftId)
            //   console.log(row.reportUrl)
            //   console.log(row.videoUrl)
            //   if (row.videoUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测视频,上传失败!'
            //     });
            //   } else if (row.reportUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测报告,上传失败!'
            //     });
            //   } else {
            //     // request.get('/Record/getSM3_PWD', {
            //     //   params: {
            //     //     videoUrl: row.videoUrl
            //     //   }
            //     // }).then(res => {
            //     //   let SM3_PWD = res.data.list[0]
            //     //   console.log(res)
            //     //   console.log(res.data.list[0])
            //     let time = new Date().getTime()
            //     let superviseCode;
            //     let recDate;
            //     let nextTestDate;
            //     let reportNum;
            //     let userName;
            //     // let reportUrl;
            //     let unit;
            //     let unitArea;
            //     let liftType;
            //     let liftNum;
            //     let liftModel;
            //     let unitNum;
            //     let safety;
            //     let safetyNum;
            //     let areaName;
            //     let dcreateDate;
            //     let createUnit;
            //     let testedNum;
            //     if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
            //       superviseCode = "/"
            //     } else {
            //       superviseCode = row.superviseCode
            //     }
            //     if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
            //       recDate = " "
            //     } else {
            //       recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     }
            //     if (row.nextTestDate == null || row.nextTestDate == "" || row.nextTestDate == "/" || row.nextTestDate == undefined) {
            //       nextTestDate = " "
            //     } else {
            //       nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     }
            //     if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
            //       reportNum = "/"
            //     } else {
            //       reportNum = row.reportNum
            //     }
            //     if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
            //       userName = "/"
            //     } else {
            //       userName = row.userName
            //     }
            //     // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
            //     //   reportUrl = "/"
            //     // } else {
            //     //   reportUrl = row.reportUrl
            //     // }
            //     if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
            //       unit = "/"
            //     } else {
            //       unit = row.unit
            //     }
            //     if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
            //       unitArea = "/"
            //     } else {
            //       unitArea = row.unitArea
            //     }
            //     if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
            //       liftType = "/"
            //     } else {
            //       liftType = row.liftType
            //     }
            //     if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
            //       liftNum = "/"
            //     } else {
            //       liftNum = row.liftNum
            //     }
            //     if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
            //       liftModel = "/"
            //     } else {
            //       liftModel = row.liftModel
            //     }
            //     if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
            //       unitNum = "/"
            //     } else {
            //       unitNum = row.unitNum
            //     }
            //     if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
            //       safety = "/"
            //     } else {
            //       safety = row.safety
            //     }
            //     if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
            //       safetyNum = "1"
            //     } else {
            //       safetyNum = row.safetyNum
            //     }
            //     if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
            //       areaName = "/"
            //     } else {
            //       areaName = row.areaName
            //     }
            //     if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
            //       dcreateDate = "/"
            //     } else {
            //       dcreateDate = row.dcreateDate
            //     }
            //     if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
            //       createUnit = "/"
            //     } else {
            //       createUnit = row.createUnit
            //     }
            //     if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
            //       testedNum = "1"
            //     } else {
            //       testedNum = row.testedNum
            //     }
            //     row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
            //     request.get('/Record/UploadUpdate', {
            //       params:{
            //         recId: row.recId,
            //         time: time,
            //         String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
            //         String2: "{\n" +
            //             "    \"OIDNO\":\"" + superviseCode + "\",\n" +
            //             "    \"ISP_DATE\":\"" + recDate + "\",\n" +
            //             "    \"NEXT_ISP_DATE\":\"" + nextTestDate + "\",\n" +
            //             "    \"ISP_ISPCOD\":\"" + reportNum + "\",\n" +
            //             "    \"ISP_CONCLU\":\"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
            //             "    \"ISP_TYPE_COD\":\"50\",\n" +
            //             "    \"ISP_MEN\":\"" + userName + "\",\n" +
            //             "    \"NOTIFI_COD\":\"/\",\n" +
            //             "    \"REP_QUERY_ADDR\":\"" + row.reportUrl + "\",\n" +
            //             "    \"USE_UNT_NAME\":\"" + unit + "\",\n" +
            //             "    \"USE_UNT_ADDR\":\"" + unitArea + "\",\n" +
            //             "    \"EQP_NAME\":\"" + liftType + "\",\n" +
            //             "    \"FACTORY_COD\":\"" + liftNum + "\",\n" +
            //             "    \"EQP_MOD\":\"" + liftModel + "\",\n" +
            //             "    \"EQP_INNER_COD\":\"" + unitNum + "\",\n" +
            //             "    \"USE_LKMEN\":\"" + safety + "\",\n" +
            //             "    \"LKMAN_PHONE\":" + safetyNum + ",\n" +
            //             "    \"EQP_USE_ADDR\":\"" + areaName + "\",\n" +
            //             "    \"MAKE_DATE\":\"" + dcreateDate + "\",\n" +
            //             "    \"MAKE_UNT_NAME\":\"" + createUnit + "\",\n" +
            //             "    \"MANT_PHONE \":" + testedNum + ",\n" +
            //             "    \"SAFE_MEN\":\"" + safety + "\",\n" +
            //             "    \"SAFE_MEN_PHONE\":" + safetyNum + ",\n" +
            //             // "    \"SAFE_MEN_PHONE\":18080808080,\n" +
            //             "    \"VIDEO_URL\":\"" + row.videoUrl + "\",\n" +
            //             // "    \"SM3_PWD\":\"" + SM3_PWD + "\"\n" +
            //             "    \"SM3_PWD\":\"/\"\n" +
            //             "}"
            //       }
            //     }).then(res => {
            //           console.log(res)
            //           console.log(res[0])
            //           if (res.data.list[0] == "true") {
            //             this.$message({
            //               type: 'success',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //             this.ticket = []
            //             request.get('/Record/TrueUploadUpdate', {
            //               params: {
            //                 recId: row.recId
            //               }
            //             })
            //             this.load()
            //           } else if (res.data.list[0] == "false") {
            //             this.$message({
            //               type: 'error',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //           }
            //         }
            //     )
            //     // })
            //   }
            //
            // }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      } else if (this.RecordFlag == 2) {
        let  name = sessionStorage.getItem("userName");
        if(name==null||name ==""||name ==undefined){
          this.$message({
            type: 'warning',
            message: '登录超时请重新登录!'
          });
          this.$router.push({path: '/login', query: {}});
          return;
        }
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认批准检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            // if (row.recStatus == 0 || row.recStatus == 1) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   submitNum: row.submitNum + 1
            //   // }
            //   if (row.plaitDate == null || row.plaitDate == "") {
            //     request.get('/Record/WeaveUpdate', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       this.ticket = [];
            //       this.load()
            //       // this.tableData = []
            //       // this.total = 0
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //
            //         console.log(res)
            //       }
            //     })
            //   }
            //   else {
            //
            //     console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
            //     request.get('/Record/WeaveUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1,
            //         plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm()
            //       // this.tableData = []
            //       // this.total = 0
            //       this.load()
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //         console.log(res)
            //         console.log(res.plaitHistory)
            //       }
            //     })
            //     // }
            //   }
            // }
            // if (row.recStatus == 5) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   auditNum: row.auditNum + 1
            //   // }
            //   if (row.processDate == null || row.processDate == "") {
            //     request.get('/Record/AuditUpdate', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1
            //       }
            //     }).then(res => {
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   } else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   auditNum: row.auditNum + 1,
            //     //   processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     request.get('/Record/AuditUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   }
            // }
            if (row.recStatus == 2) {

              if (this.ThisForm.new_pzsj == null || this.ThisForm.new_pzsj == undefined || this.ThisForm.new_pzsj == "" || this.ThisForm.new_pzsj == '' || this.ThisForm.new_pzsj == "null" || this.ThisForm.new_pzsj == " ") {
                this.$message({
                  type: 'warning',
                  message: '批准时间未选择!'
                });
              } else {
                request.get('/Record/ApproveUpdate', {
                  params:{
                    recId: row.recId,
                    ratifyNum: row.ratifyNum + 1,
                    userName: localStorage.getItem("userName"),
                    pzTime: this.ThisForm.new_pzsj
                  }
                }).then(res => {
                  // this.submitForm(this.formchecked, this.ThisForm)
                  this.pzsj = false
                  if (res === 0) { //已批准，直接刷新
                    this.$message({
                      type: 'success',
                      message: '数据已操作!'
                    });
                    this.ticket = [];
                    this.load();
                  }
                  if (res > 0) {
                    this.tocreatReport(row, 2); //重新生成报告
                  }
                  if (res <0) {
                    this.$message({
                      type: 'error',
                      message: '批准失败!'
                    });
                  }
                })
              }

            }
            // if (row.recStatus == 3) {
            //   // console.log(row)
            //   console.log(row.liftId)
            //   console.log(row.reportUrl)
            //   console.log(row.videoUrl)
            //   if (row.videoUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测视频,上传失败!'
            //     });
            //   } else if (row.reportUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测报告,上传失败!'
            //     });
            //   } else {
            //     // request.get('/Record/getSM3_PWD', {
            //     //   params: {
            //     //     videoUrl: row.videoUrl
            //     //   }
            //     // }).then(res => {
            //     //   let SM3_PWD = res.data.list[0]
            //     //   console.log(res)
            //     //   console.log(res.data.list[0])
            //     let time = new Date().getTime()
            //     let superviseCode;
            //     let recDate;
            //     let nextTestDate;
            //     let reportNum;
            //     let userName;
            //     // let reportUrl;
            //     let unit;
            //     let unitArea;
            //     let liftType;
            //     let liftNum;
            //     let liftModel;
            //     let unitNum;
            //     let safety;
            //     let safetyNum;
            //     let areaName;
            //     let dcreateDate;
            //     let createUnit;
            //     let testedNum;
            //     if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
            //       superviseCode = "/"
            //     } else {
            //       superviseCode = row.superviseCode
            //     }
            //     if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
            //       recDate = " "
            //     } else {
            //       recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     }
            //     if (row.nextTestDate == null || row.nextTestDate == "" || row.nextTestDate == "/" || row.nextTestDate == undefined) {
            //       nextTestDate = " "
            //     } else {
            //       nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     }
            //     if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
            //       reportNum = "/"
            //     } else {
            //       reportNum = row.reportNum
            //     }
            //     if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
            //       userName = "/"
            //     } else {
            //       userName = row.userName
            //     }
            //     // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
            //     //   reportUrl = "/"
            //     // } else {
            //     //   reportUrl = row.reportUrl
            //     // }
            //     if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
            //       unit = "/"
            //     } else {
            //       unit = row.unit
            //     }
            //     if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
            //       unitArea = "/"
            //     } else {
            //       unitArea = row.unitArea
            //     }
            //     if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
            //       liftType = "/"
            //     } else {
            //       liftType = row.liftType
            //     }
            //     if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
            //       liftNum = "/"
            //     } else {
            //       liftNum = row.liftNum
            //     }
            //     if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
            //       liftModel = "/"
            //     } else {
            //       liftModel = row.liftModel
            //     }
            //     if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
            //       unitNum = "/"
            //     } else {
            //       unitNum = row.unitNum
            //     }
            //     if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
            //       safety = "/"
            //     } else {
            //       safety = row.safety
            //     }
            //     if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
            //       safetyNum = "1"
            //     } else {
            //       safetyNum = row.safetyNum
            //     }
            //     if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
            //       areaName = "/"
            //     } else {
            //       areaName = row.areaName
            //     }
            //     if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
            //       dcreateDate = "/"
            //     } else {
            //       dcreateDate = row.dcreateDate
            //     }
            //     if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
            //       createUnit = "/"
            //     } else {
            //       createUnit = row.createUnit
            //     }
            //     if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
            //       testedNum = "1"
            //     } else {
            //       testedNum = row.testedNum
            //     }
            //     row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
            //     request.get('/Record/UploadUpdate', {
            //       params:{
            //         recId: row.recId,
            //         time: time,
            //         String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
            //         String2: "{\n" +
            //             "    \"OIDNO\":\"" + superviseCode + "\",\n" +
            //             "    \"ISP_DATE\":\"" + recDate + "\",\n" +
            //             "    \"NEXT_ISP_DATE\":\"" + nextTestDate + "\",\n" +
            //             "    \"ISP_ISPCOD\":\"" + reportNum + "\",\n" +
            //             "    \"ISP_CONCLU\":\"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
            //             "    \"ISP_TYPE_COD\":\"50\",\n" +
            //             "    \"ISP_MEN\":\"" + userName + "\",\n" +
            //             "    \"NOTIFI_COD\":\"/\",\n" +
            //             "    \"REP_QUERY_ADDR\":\"" + row.reportUrl + "\",\n" +
            //             "    \"USE_UNT_NAME\":\"" + unit + "\",\n" +
            //             "    \"USE_UNT_ADDR\":\"" + unitArea + "\",\n" +
            //             "    \"EQP_NAME\":\"" + liftType + "\",\n" +
            //             "    \"FACTORY_COD\":\"" + liftNum + "\",\n" +
            //             "    \"EQP_MOD\":\"" + liftModel + "\",\n" +
            //             "    \"EQP_INNER_COD\":\"" + unitNum + "\",\n" +
            //             "    \"USE_LKMEN\":\"" + safety + "\",\n" +
            //             "    \"LKMAN_PHONE\":" + safetyNum + ",\n" +
            //             "    \"EQP_USE_ADDR\":\"" + areaName + "\",\n" +
            //             "    \"MAKE_DATE\":\"" + dcreateDate + "\",\n" +
            //             "    \"MAKE_UNT_NAME\":\"" + createUnit + "\",\n" +
            //             "    \"MANT_PHONE \":" + testedNum + ",\n" +
            //             "    \"SAFE_MEN\":\"" + safety + "\",\n" +
            //             "    \"SAFE_MEN_PHONE\":" + safetyNum + ",\n" +
            //             // "    \"SAFE_MEN_PHONE\":18080808080,\n" +
            //             "    \"VIDEO_URL\":\"" + row.videoUrl + "\",\n" +
            //             // "    \"SM3_PWD\":\"" + SM3_PWD + "\"\n" +
            //             "    \"SM3_PWD\":\"/\"\n" +
            //             "}"
            //       }
            //     }).then(res => {
            //           console.log(res)
            //           console.log(res[0])
            //           if (res.data.list[0] == "true") {
            //             this.$message({
            //               type: 'success',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //             this.ticket = []
            //             request.get('/Record/TrueUploadUpdate', {
            //               params: {
            //                 recId: row.recId
            //               }
            //             })
            //             this.load()
            //           } else if (res.data.list[0] == "false") {
            //             this.$message({
            //               type: 'error',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //           }
            //         }
            //     )
            //     // })
            //   }
            //
            // }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      } else if (this.RecordFlag == 4) {
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认上传检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            // if (row.recStatus == 0 || row.recStatus == 1) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   submitNum: row.submitNum + 1
            //   // }
            //   if (row.plaitDate == null || row.plaitDate == "") {
            //     request.get('/Record/WeaveUpdate', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       this.ticket = [];
            //       this.load()
            //       // this.tableData = []
            //       // this.total = 0
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //
            //         console.log(res)
            //       }
            //     })
            //   }
            //   else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   submitNum: row.submitNum + 1,
            //     //   plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
            //     request.get('/Record/WeaveUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1,
            //         plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm()
            //       // this.tableData = []
            //       // this.total = 0
            //       this.load()
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //         console.log(res)
            //         console.log(res.plaitHistory)
            //       }
            //     })
            //     // }
            //   }
            // }
            // if (row.recStatus == 5) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   auditNum: row.auditNum + 1
            //   // }
            //   if (row.processDate == null || row.processDate == "") {
            //     request.get('/Record/AuditUpdate', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1
            //       }
            //     }).then(res => {
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   } else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   auditNum: row.auditNum + 1,
            //     //   processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     request.get('/Record/AuditUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   }
            // }
            // if (row.recStatus == 2) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   ratifyNum: row.ratifyNum + 1
            //   // }
            //   request.get('/Record/ApproveUpdate', {
            //     params:{
            //       recId: row.recId,
            //       ratifyNum: row.ratifyNum + 1
            //     }
            //   }).then(res => {
            //     // this.submitForm(this.formchecked, this.ThisForm)
            //     if (res === 0) { //已批准，直接刷新
            //       this.$message({
            //         type: 'success',
            //         message: '数据已操作!'
            //       });
            //       this.ticket = [];
            //       this.load();
            //     }
            //     if (res > 0) {
            //       this.tocreatReport(row, 2); //重新生成报告
            //     }
            //     if (res <0) {
            //       this.$message({
            //         type: 'error',
            //         message: '批准失败!'
            //       });
            //     }
            //     // this.ticket = []
            //     // this.load()
            //     // if (res > 0) {
            //     //   this.$message({
            //     //     type: 'success',
            //     //     message: '批准成功!'
            //     //   });
            //     // }
            //   })
            // }
            if (row.recStatus == 3) {
              // console.log(row)
              console.log(row.liftId)
              console.log(row.reportUrl)
              console.log(row.videoUrl)
              if (row.videoUrl == null) {
                // this.$message({
                //   type: 'error',
                //   message: '该条数据暂无检测视频,上传失败!'
                // });
                this.$confirm('该条数据暂无检测视频,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              } else if (row.stampReportUrl == null) {
                // this.$message({
                //   type: 'error',
                //   message: '该条数据暂无盖章检测报告,上传失败!'
                // });
                this.$confirm('该条数据暂无盖章检测报告,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              }
            // else if(row.)
            else {
                request.get('/Record/getSM3_PWD', {
                  params: {
                    videoUrl: row.videoUrl
                  }
                }).then(res => {
                  let SM3_PWD = res.data.list[0]
                  console.log(res)
                  console.log(res.data.list[0])
                let time = new Date().getTime()
                let superviseCode;
                let recDate;
                // let nextDate;
                let reportNum;
                // let userName;
                // let reportUrl;
                let unit;
                let unitArea;
                let liftType;
                let liftNum;
                let liftModel;
                let unitNum;
                let safety;
                let safetyNum;
                let areaName;
                let dcreateDate;
                let createUnit;
                let testedNum;
                let userAlias;
                if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
                  superviseCode = ""
                } else {
                  superviseCode = row.superviseCode.trim()
                }
                if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
                  recDate = " "
                } else {
                  recDate = this.formatDate(row.recDate, "yyyy-MM-dd").trim()
                }
                // if (row.nextDate == null || row.nextDate == "" || row.nextDate == "/" || row.nextDate == undefined) {
                //   nextDate = " "
                // } else {
                //   // nextDate = this.formatDate(row.nextDate, "yyyy-MM-dd")
                //   nextDate = " "
                // }
                if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
                  reportNum = ""
                } else {
                  reportNum = row.reportNum.trim()
                }
                // if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
                //   userName = ""
                // } else {
                //   userName = row.userName
                // }
                if (row.userAlias == null || row.userAlias == "" || row.userAlias == "/" || row.userAlias == undefined) {
                  userAlias = ""
                } else {
                  userAlias = row.userAlias.trim()
                }
                // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
                //   reportUrl = "/"
                // } else {
                //   reportUrl = row.reportUrl
                // }
                if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
                  unit = ""
                } else {
                  unit = row.unit.trim()
                }
                if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
                  unitArea = ""
                } else {
                  unitArea = row.unitArea.trim()
                }
                if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
                  liftType = ""
                } else {
                  liftType = row.liftType.trim()
                }
                if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
                  liftNum = ""
                } else {
                  liftNum = row.liftNum.trim()
                }
                if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
                  liftModel = ""
                } else {
                  liftModel = row.liftModel.trim()
                }
                if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
                  unitNum = ""
                } else {
                  unitNum = row.unitNum.trim()
                }
                if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
                  safety = ""
                } else {
                  safety = row.safety.trim()
                }
                if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
                  safetyNum = "1"
                } else {
                  safetyNum = row.safetyNum.trim()
                }
                if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
                  areaName = ""
                } else {
                  areaName = row.areaName.trim()
                }
                if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
                  dcreateDate = ""
                } else {
                  dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd").trim()

                }
                if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
                  createUnit = ""
                } else {
                  createUnit = row.createUnit.trim()
                }
                if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
                  testedNum = "1"
                } else {
                  testedNum = row.testedNum.trim()
                }
                row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
                row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
                row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
                request.get('/Record/UploadUpdate', {
                  params:{
                    recId: row.recId,
                    time: time,
                    String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
                    String2:"{\n" +
                        "    \"OIDNO\":\""+superviseCode+"\",\n" +
                        "    \"ISP_DATE\":\""+recDate+"\",\n" +
                        "    \"NEXT_ISP_DATE\":\" \",\n" +
                        "    \"ISP_ISPCOD\":\""+reportNum+"\",\n" +
                        "    \"ISP_CONCLU\": \"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
                        "    \"ISP_TYPE_COD\":\"50\",\n" +
                        "    \"ISP_MEN\":\""+userAlias+"\",\n" +
                        "    \"NOTIFI_COD\":\"\",\n" +
                        "    \"REP_QUERY_ADDR\":\""+row.stampReportUrl.trim()+"\",\n" +
                        "    \"ISP_PWD\":\"\",\n" +
                        "    \"USE_UNT_NAME\":\""+unit+"\",\n" +
                        "    \"USE_UNT_ADDR\":\""+unitArea+"\",\n" +
                        "    \"EQP_NAME\":\""+liftType+"\",\n" +
                        "    \"FACTORY_COD\":\""+liftNum+"\",\n" +
                        "    \"EQP_MOD\":\""+liftModel+"\",\n" +
                        "    \"EQP_INNER_COD\":\""+unitNum+"\",\n" +
                        "    \"USE_LKMEN\":\"" + safety + "\",\n" +
                        "    \"LKMAN_PHONE\":\""+safetyNum+"\",\n" +
                        "    \"EQP_USE_ADDR\":\""+areaName+"\",\n" +
                        "    \"MAKE_DATE\":\""+dcreateDate+"\",\n" +
                        "    \"MAKE_UNT_NAME\":\""+createUnit+"\",\n" +
                        "    \"MANT_PHONE \":\""+testedNum+"\",\n" +
                        "    \"SAFE_MEN\":\"" + safety + "\",\n" +
                        "    \"SAFE_MEN_PHONE\":\""+safetyNum+"\",\n" +
                        "    \"VIDEO_URL\":\""+row.videoUrl.trim()+"\",\n" +
                        "    \"SM3_PWD\":\""+SM3_PWD+"\",\n" +
                        "    \"ORIGINAL_RECORDS_URL\":\"\",\n" +
                        "    \"ORIGINAL_RECORDS_PWD\":\"\",\n" +
                        "    \"MEMORANDUM_URL\":\"\",\n" +
                        "    \"MEMORANDUM_PWD\":\"\",\n" +
                        "    \"NOT_ELIGIBLE_ITEMS\":[]\n" +
                        "}"
                  }
                }).then(res => {
                      console.log(res)
                      console.log(res[0])
                  if (res.data.list[0] == "true") {
                    this.$confirm(res.data.list[1], '报告上传提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '关闭',
                      type: 'success',
                      closeOnClickModal: false
                    }).then(() => {
                      this.ticket = []
                      request.get('/Record/TrueUploadUpdate', {
                        params: {
                          recId: row.recId
                        }
                      })
                      this.load()
                    }).catch(() => {
                      this.ticket = []
                      request.get('/Record/TrueUploadUpdate', {
                        params: {
                          recId: row.recId
                        }
                      })
                      this.load()
                    });
                  } else if (res.data.list[0] == "false") {
                    this.$confirm(res.data.list[1], '报告上传提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '关闭',
                      type: 'warning',
                      closeOnClickModal: false
                    }).then(() => {
                    }).catch(() => {
                    });
                  } else if (res.data.list[3] === 0) {
                    this.$confirm(res.data.list[2], '报告上传提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '关闭',
                      type: 'warning',
                      closeOnClickModal: false
                    }).then(() => {
                    }).catch(() => {
                    });
                  }
                })
                })
              }

            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      } else if (this.RecordFlag == 5) {
        let  name = sessionStorage.getItem("userName");
        if(name==null||name ==""||name ==undefined){
          this.$message({
            type: 'warning',
            message: '登录超时请重新登录!'
          });
          this.$router.push({path: '/login', query: {}});
          return;
        }
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认审核检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            // this.shsj = true
            this.disabledQualified = true
            // if (row.recStatus == 0 || row.recStatus == 1) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   submitNum: row.submitNum + 1
            //   // }
            //   if (row.plaitDate == null || row.plaitDate == "") {
            //     request.get('/Record/WeaveUpdate', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       this.ticket = [];
            //       this.load()
            //       // this.tableData = []
            //       // this.total = 0
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //
            //         console.log(res)
            //       }
            //     })
            //   }
            //   else {
            //
            //     console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
            //     request.get('/Record/WeaveUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1,
            //         plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm()
            //       // this.tableData = []
            //       // this.total = 0
            //       this.load()
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //         console.log(res)
            //         console.log(res.plaitHistory)
            //       }
            //     })
            //     // }
            //   }
            // }
            if (row.recStatus == 5) {
              if (row.processDate == null || row.processDate == "") {
                if (this.ThisForm.new_shsj == null || this.ThisForm.new_shsj == undefined || this.ThisForm.new_shsj == "" || this.ThisForm.new_shsj == '' || this.ThisForm.new_shsj == "null" || this.ThisForm.new_shsj == " ") {
                  this.$message({
                    type: 'warning',
                    message: '审核时间未选择!'
                  });
                } else {
                  request.get('/Record/AuditUpdate', {
                    params:{
                      recId: row.recId,
                      auditNum: row.auditNum + 1,
                      userName: localStorage.getItem("userName"),
                      shTime: this.ThisForm.new_shsj
                    }
                  }).then(res => {
                    // this.submitForm(this.formchecked, this.ThisForm)
                    this.shsj = false
                    if (res === 0) { //已审核，直接刷新
                      this.$message({
                        type: 'success',
                        message: '数据已操作!'
                      });
                      this.ticket = []
                      this.load()
                    }
                    if (res > 0) {
                      console.log("审核结果");
                      this.tocreatReport(row, 1); //重新生成报告
                    }
                    if (res < 0) {
                      this.$message({
                        type: 'success',
                        message: '审核失败!'
                      });
                    }
                  })
                }
              } else {
                if (this.ThisForm.new_shsj == null || this.ThisForm.new_shsj == undefined || this.ThisForm.new_shsj == "" || this.ThisForm.new_shsj == '' || this.ThisForm.new_shsj == "null" || this.ThisForm.new_shsj == " ") {
                  this.$message({
                    type: 'warning',
                    message: '审核时间未选择!'
                  });
                } else {
                  request.get('/Record/AuditUpdate2', {
                    params:{
                      recId: row.recId,
                      auditNum: row.auditNum + 1,
                      processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss"),
                      userName: localStorage.getItem("userName"),
                      shTime: this.ThisForm.new_shsj
                    }
                  }).then(res => {
                    this.shsj = false
                    console.log("she审核按钮："+res)
                    // this.submitForm(this.formchecked, this.ThisForm)
                    if (res === 0) { //已审核，直接刷新
                      this.$message({
                        type: 'success',
                        message: '数据已操作!'
                      });
                      this.ticket = []
                      this.load()
                    }
                    if (res > 0) {
                      console.log("审核结果");
                      this.tocreatReport(row, 1); //重新生成报告
                    }
                    if (res < 0) {
                      this.$message({
                        type: 'success',
                        message: '审核失败!'
                      });
                    }
                  })
                }
              }
            }
            // if (row.recStatus == 2) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   ratifyNum: row.ratifyNum + 1
            //   // }
            //   request.get('/Record/ApproveUpdate', {
            //     params:{
            //       recId: row.recId,
            //       ratifyNum: row.ratifyNum + 1
            //     }
            //   }).then(res => {
            //     // this.submitForm(this.formchecked, this.ThisForm)
            //     if (res === 0) { //已批准，直接刷新
            //       this.$message({
            //         type: 'success',
            //         message: '数据已操作!'
            //       });
            //       this.ticket = [];
            //       this.load();
            //     }
            //     if (res > 0) {
            //       this.tocreatReport(row, 2); //重新生成报告
            //     }
            //     if (res <0) {
            //       this.$message({
            //         type: 'error',
            //         message: '批准失败!'
            //       });
            //     }
            //     // this.ticket = []
            //     // this.load()
            //     // if (res > 0) {
            //     //   this.$message({
            //     //     type: 'success',
            //     //     message: '批准成功!'
            //     //   });
            //     // }
            //   })
            // }
            // if (row.recStatus == 3) {
            //   // console.log(row)
            //   console.log(row.liftId)
            //   console.log(row.reportUrl)
            //   console.log(row.videoUrl)
            //   if (row.videoUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测视频,上传失败!'
            //     });
            //   } else if (row.reportUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测报告,上传失败!'
            //     });
            //   } else {
            //     // request.get('/Record/getSM3_PWD', {
            //     //   params: {
            //     //     videoUrl: row.videoUrl
            //     //   }
            //     // }).then(res => {
            //     //   let SM3_PWD = res.data.list[0]
            //     //   console.log(res)
            //     //   console.log(res.data.list[0])
            //     let time = new Date().getTime()
            //     let superviseCode;
            //     let recDate;
            //     let nextTestDate;
            //     let reportNum;
            //     let userName;
            //     // let reportUrl;
            //     let unit;
            //     let unitArea;
            //     let liftType;
            //     let liftNum;
            //     let liftModel;
            //     let unitNum;
            //     let safety;
            //     let safetyNum;
            //     let areaName;
            //     let dcreateDate;
            //     let createUnit;
            //     let testedNum;
            //     if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
            //       superviseCode = "/"
            //     } else {
            //       superviseCode = row.superviseCode
            //     }
            //     if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
            //       recDate = " "
            //     } else {
            //       recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     }
            //     if (row.nextTestDate == null || row.nextTestDate == "" || row.nextTestDate == "/" || row.nextTestDate == undefined) {
            //       nextTestDate = " "
            //     } else {
            //       nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     }
            //     if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
            //       reportNum = "/"
            //     } else {
            //       reportNum = row.reportNum
            //     }
            //     if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
            //       userName = "/"
            //     } else {
            //       userName = row.userName
            //     }
            //     // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
            //     //   reportUrl = "/"
            //     // } else {
            //     //   reportUrl = row.reportUrl
            //     // }
            //     if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
            //       unit = "/"
            //     } else {
            //       unit = row.unit
            //     }
            //     if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
            //       unitArea = "/"
            //     } else {
            //       unitArea = row.unitArea
            //     }
            //     if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
            //       liftType = "/"
            //     } else {
            //       liftType = row.liftType
            //     }
            //     if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
            //       liftNum = "/"
            //     } else {
            //       liftNum = row.liftNum
            //     }
            //     if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
            //       liftModel = "/"
            //     } else {
            //       liftModel = row.liftModel
            //     }
            //     if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
            //       unitNum = "/"
            //     } else {
            //       unitNum = row.unitNum
            //     }
            //     if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
            //       safety = "/"
            //     } else {
            //       safety = row.safety
            //     }
            //     if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
            //       safetyNum = "1"
            //     } else {
            //       safetyNum = row.safetyNum
            //     }
            //     if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
            //       areaName = "/"
            //     } else {
            //       areaName = row.areaName
            //     }
            //     if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
            //       dcreateDate = "/"
            //     } else {
            //       dcreateDate = row.dcreateDate
            //     }
            //     if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
            //       createUnit = "/"
            //     } else {
            //       createUnit = row.createUnit
            //     }
            //     if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
            //       testedNum = "1"
            //     } else {
            //       testedNum = row.testedNum
            //     }
            //     row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
            //     request.get('/Record/UploadUpdate', {
            //       params:{
            //         recId: row.recId,
            //         time: time,
            //         String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
            //         String2: "{\n" +
            //             "    \"OIDNO\":\"" + superviseCode + "\",\n" +
            //             "    \"ISP_DATE\":\"" + recDate + "\",\n" +
            //             "    \"NEXT_ISP_DATE\":\"" + nextTestDate + "\",\n" +
            //             "    \"ISP_ISPCOD\":\"" + reportNum + "\",\n" +
            //             "    \"ISP_CONCLU\":\"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
            //             "    \"ISP_TYPE_COD\":\"50\",\n" +
            //             "    \"ISP_MEN\":\"" + userName + "\",\n" +
            //             "    \"NOTIFI_COD\":\"/\",\n" +
            //             "    \"REP_QUERY_ADDR\":\"" + row.reportUrl + "\",\n" +
            //             "    \"USE_UNT_NAME\":\"" + unit + "\",\n" +
            //             "    \"USE_UNT_ADDR\":\"" + unitArea + "\",\n" +
            //             "    \"EQP_NAME\":\"" + liftType + "\",\n" +
            //             "    \"FACTORY_COD\":\"" + liftNum + "\",\n" +
            //             "    \"EQP_MOD\":\"" + liftModel + "\",\n" +
            //             "    \"EQP_INNER_COD\":\"" + unitNum + "\",\n" +
            //             "    \"USE_LKMEN\":\"" + safety + "\",\n" +
            //             "    \"LKMAN_PHONE\":" + safetyNum + ",\n" +
            //             "    \"EQP_USE_ADDR\":\"" + areaName + "\",\n" +
            //             "    \"MAKE_DATE\":\"" + dcreateDate + "\",\n" +
            //             "    \"MAKE_UNT_NAME\":\"" + createUnit + "\",\n" +
            //             "    \"MANT_PHONE \":" + testedNum + ",\n" +
            //             "    \"SAFE_MEN\":\"" + safety + "\",\n" +
            //             "    \"SAFE_MEN_PHONE\":" + safetyNum + ",\n" +
            //             // "    \"SAFE_MEN_PHONE\":18080808080,\n" +
            //             "    \"VIDEO_URL\":\"" + row.videoUrl + "\",\n" +
            //             // "    \"SM3_PWD\":\"" + SM3_PWD + "\"\n" +
            //             "    \"SM3_PWD\":\"/\"\n" +
            //             "}"
            //       }
            //     }).then(res => {
            //           console.log(res)
            //           console.log(res[0])
            //           if (res.data.list[0] == "true") {
            //             this.$message({
            //               type: 'success',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //             this.ticket = []
            //             request.get('/Record/TrueUploadUpdate', {
            //               params: {
            //                 recId: row.recId
            //               }
            //             })
            //             this.load()
            //           } else if (res.data.list[0] == "false") {
            //             this.$message({
            //               type: 'error',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //           }
            //         }
            //     )
            //     // })
            //   }
            //
            // }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      }
    },

    OpenShsj(row) {
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        this.shsj = true
      }
    },
    OpenPzsj(row) {
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        this.pzsj = true
      }
    },

    Audit2(row,id) {
      if (row.recStatus == 0 && row.recResult == 1){
        this.$confirm('该条记录还未进行重新编辑！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
        }).then(() => {
          this.$message({
            type: 'info',
            message: '请前往APP端进行重新编辑'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '请前往APP端进行重新编辑'
          });
        });
        return;
      }
      let tip = '是否确认审核检测记录?'
      if (this.RecordFlag == 0 || this.RecordFlag == 1) {
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认提交审核检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            if (row.recStatus == 0 || row.recStatus == 1) {

              if (row.plaitDate == null || row.plaitDate == "") {
                request.get('/Record/WeaveUpdate', {
                  params:{
                    recId: row.recId,
                    submitNum: row.submitNum + 1,
                    userName: sessionStorage.getItem("userName")
                  }
                }).then(res => {
                  console.log("she审核按钮："+res)
                  this.ticket = [];
                  this.load()
                  if (res > 0) {
                    this.$message({
                      type: 'success',
                      message: '提交成功!'
                    });

                    console.log(res)
                  }
                })
              }
              else {
                console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
                request.get('/Record/WeaveUpdate2', {
                  params:{
                    recId: row.recId,
                    submitNum: row.submitNum + 1,
                    plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
                  }
                }).then(res => {
                  console.log("she审核按钮："+res)
                  // this.submitForm()
                  // this.tableData = []
                  // this.total = 0
                  this.load()
                  if (res > 0) {
                    this.$message({
                      type: 'success',
                      message: '提交成功!'
                    });
                    console.log(res)
                    console.log(res.plaitHistory)
                  }
                })
                // }
              }
            }
            // if (row.recStatus == 5) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   auditNum: row.auditNum + 1
            //   // }
            //   if (row.processDate == null || row.processDate == "") {
            //     request.get('/Record/AuditUpdate', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         userName: sessionStorage.getItem("userName")
            //       }
            //     }).then(res => {
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   } else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   auditNum: row.auditNum + 1,
            //     //   processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     request.get('/Record/AuditUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   }
            // }
            // if (row.recStatus == 2) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   ratifyNum: row.ratifyNum + 1
            //   // }
            //   request.get('/Record/ApproveUpdate', {
            //     params:{
            //       recId: row.recId,
            //       ratifyNum: row.ratifyNum + 1,
            //       userName: sessionStorage.getItem("userName")
            //     }
            //   }).then(res => {
            //     // this.submitForm(this.formchecked, this.ThisForm)
            //     if (res === 0) { //已批准，直接刷新
            //       this.$message({
            //         type: 'success',
            //         message: '数据已操作!'
            //       });
            //       this.ticket = [];
            //       this.load();
            //     }
            //     if (res > 0) {
            //       this.tocreatReport(row, 2); //重新生成报告
            //     }
            //     if (res <0) {
            //       this.$message({
            //         type: 'error',
            //         message: '批准失败!'
            //       });
            //     }
            //     // this.ticket = []
            //     // this.load()
            //     // if (res > 0) {
            //     //   this.$message({
            //     //     type: 'success',
            //     //     message: '批准成功!'
            //     //   });
            //     // }
            //   })
            // }
            // if (row.recStatus == 3) {
            //   // console.log(row)
            //   console.log(row.liftId)
            //   console.log(row.reportUrl)
            //   console.log(row.videoUrl)
            //   if (row.videoUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测视频,上传失败!'
            //     });
            //   } else if (row.reportUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测报告,上传失败!'
            //     });
            //   } else {
            //     // request.get('/Record/getSM3_PWD', {
            //     //   params: {
            //     //     videoUrl: row.videoUrl
            //     //   }
            //     // }).then(res => {
            //     //   let SM3_PWD = res.data.list[0]
            //     //   console.log(res)
            //     //   console.log(res.data.list[0])
            //     let time = new Date().getTime()
            //     let superviseCode;
            //     let recDate;
            //     let nextTestDate;
            //     let reportNum;
            //     let userName;
            //     // let reportUrl;
            //     let unit;
            //     let unitArea;
            //     let liftType;
            //     let liftNum;
            //     let liftModel;
            //     let unitNum;
            //     let safety;
            //     let safetyNum;
            //     let areaName;
            //     let dcreateDate;
            //     let createUnit;
            //     let testedNum;
            //     if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
            //       superviseCode = "/"
            //     } else {
            //       superviseCode = row.superviseCode
            //     }
            //     if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
            //       recDate = " "
            //     } else {
            //       recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     }
            //     if (row.nextTestDate == null || row.nextTestDate == "" || row.nextTestDate == "/" || row.nextTestDate == undefined) {
            //       nextTestDate = " "
            //     } else {
            //       nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     }
            //     if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
            //       reportNum = "/"
            //     } else {
            //       reportNum = row.reportNum
            //     }
            //     if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
            //       userName = "/"
            //     } else {
            //       userName = row.userName
            //     }
            //     // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
            //     //   reportUrl = "/"
            //     // } else {
            //     //   reportUrl = row.reportUrl
            //     // }
            //     if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
            //       unit = "/"
            //     } else {
            //       unit = row.unit
            //     }
            //     if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
            //       unitArea = "/"
            //     } else {
            //       unitArea = row.unitArea
            //     }
            //     if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
            //       liftType = "/"
            //     } else {
            //       liftType = row.liftType
            //     }
            //     if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
            //       liftNum = "/"
            //     } else {
            //       liftNum = row.liftNum
            //     }
            //     if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
            //       liftModel = "/"
            //     } else {
            //       liftModel = row.liftModel
            //     }
            //     if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
            //       unitNum = "/"
            //     } else {
            //       unitNum = row.unitNum
            //     }
            //     if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
            //       safety = "/"
            //     } else {
            //       safety = row.safety
            //     }
            //     if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
            //       safetyNum = "1"
            //     } else {
            //       safetyNum = row.safetyNum
            //     }
            //     if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
            //       areaName = "/"
            //     } else {
            //       areaName = row.areaName
            //     }
            //     if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
            //       dcreateDate = "/"
            //     } else {
            //       dcreateDate = row.dcreateDate
            //     }
            //     if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
            //       createUnit = "/"
            //     } else {
            //       createUnit = row.createUnit
            //     }
            //     if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
            //       testedNum = "1"
            //     } else {
            //       testedNum = row.testedNum
            //     }
            //     row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
            //     request.get('/Record/UploadUpdate', {
            //       params:{
            //         recId: row.recId,
            //         time: time,
            //         String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
            //         String2: "{\n" +
            //             "    \"OIDNO\":\"" + superviseCode + "\",\n" +
            //             "    \"ISP_DATE\":\"" + recDate + "\",\n" +
            //             "    \"NEXT_ISP_DATE\":\"" + nextTestDate + "\",\n" +
            //             "    \"ISP_ISPCOD\":\"" + reportNum + "\",\n" +
            //             "    \"ISP_CONCLU\":\"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
            //             "    \"ISP_TYPE_COD\":\"50\",\n" +
            //             "    \"ISP_MEN\":\"" + userName + "\",\n" +
            //             "    \"NOTIFI_COD\":\"/\",\n" +
            //             "    \"REP_QUERY_ADDR\":\"" + row.reportUrl + "\",\n" +
            //             "    \"USE_UNT_NAME\":\"" + unit + "\",\n" +
            //             "    \"USE_UNT_ADDR\":\"" + unitArea + "\",\n" +
            //             "    \"EQP_NAME\":\"" + liftType + "\",\n" +
            //             "    \"FACTORY_COD\":\"" + liftNum + "\",\n" +
            //             "    \"EQP_MOD\":\"" + liftModel + "\",\n" +
            //             "    \"EQP_INNER_COD\":\"" + unitNum + "\",\n" +
            //             "    \"USE_LKMEN\":\"" + safety + "\",\n" +
            //             "    \"LKMAN_PHONE\":" + safetyNum + ",\n" +
            //             "    \"EQP_USE_ADDR\":\"" + areaName + "\",\n" +
            //             "    \"MAKE_DATE\":\"" + dcreateDate + "\",\n" +
            //             "    \"MAKE_UNT_NAME\":\"" + createUnit + "\",\n" +
            //             "    \"MANT_PHONE \":" + testedNum + ",\n" +
            //             "    \"SAFE_MEN\":\"" + safety + "\",\n" +
            //             "    \"SAFE_MEN_PHONE\":" + safetyNum + ",\n" +
            //             // "    \"SAFE_MEN_PHONE\":18080808080,\n" +
            //             "    \"VIDEO_URL\":\"" + row.videoUrl + "\",\n" +
            //             // "    \"SM3_PWD\":\"" + SM3_PWD + "\"\n" +
            //             "    \"SM3_PWD\":\"/\"\n" +
            //             "}"
            //       }
            //     }).then(res => {
            //           console.log(res)
            //           console.log(res[0])
            //           if (res.data.list[0] == "true") {
            //             this.$message({
            //               type: 'success',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //             this.ticket = []
            //             request.get('/Record/TrueUploadUpdate', {
            //               params: {
            //                 recId: row.recId
            //               }
            //             })
            //             this.load()
            //           } else if (res.data.list[0] == "false") {
            //             this.$message({
            //               type: 'error',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //           }
            //         }
            //     )
            //     // })
            //   }
            //
            // }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      } else if (this.RecordFlag == 2) {
        let  name = sessionStorage.getItem("userName");
        if(name==null||name ==""||name ==undefined){
          this.$message({
            type: 'warning',
            message: '登录超时请重新登录!'
          });
          this.$router.push({path: '/login', query: {}});
          return;
        }
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认批准检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            // if (row.recStatus == 0 || row.recStatus == 1) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   submitNum: row.submitNum + 1
            //   // }
            //   if (row.plaitDate == null || row.plaitDate == "") {
            //     request.get('/Record/WeaveUpdate', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       this.ticket = [];
            //       this.load()
            //       // this.tableData = []
            //       // this.total = 0
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //
            //         console.log(res)
            //       }
            //     })
            //   }
            //   else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   submitNum: row.submitNum + 1,
            //     //   plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
            //     request.get('/Record/WeaveUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1,
            //         plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm()
            //       // this.tableData = []
            //       // this.total = 0
            //       this.load()
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //         console.log(res)
            //         console.log(res.plaitHistory)
            //       }
            //     })
            //     // }
            //   }
            // }
            // if (row.recStatus == 5) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   auditNum: row.auditNum + 1
            //   // }
            //   if (row.processDate == null || row.processDate == "") {
            //     request.get('/Record/AuditUpdate', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1
            //       }
            //     }).then(res => {
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   } else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   auditNum: row.auditNum + 1,
            //     //   processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     request.get('/Record/AuditUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   }
            // }
            if (row.recStatus == 2) {

              request.get('/Record/ApproveUpdate', {
                params:{
                  recId: row.recId,
                  ratifyNum: row.ratifyNum + 1
                }
              }).then(res => {
                // this.submitForm(this.formchecked, this.ThisForm)
                if (res === 0) { //已批准，直接刷新
                  this.$message({
                    type: 'success',
                    message: '数据已操作!'
                  });
                  this.ticket = [];
                  this.load();
                }
                if (res > 0) {
                  this.tocreatReport(row, 2); //重新生成报告
                }
                if (res <0) {
                  this.$message({
                    type: 'error',
                    message: '批准失败!'
                  });
                }

              })
            }
            // if (row.recStatus == 3) {
            //   // console.log(row)
            //   console.log(row.liftId)
            //   console.log(row.reportUrl)
            //   console.log(row.videoUrl)
            //   if (row.videoUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测视频,上传失败!'
            //     });
            //   } else if (row.reportUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测报告,上传失败!'
            //     });
            //   } else {
            //     // request.get('/Record/getSM3_PWD', {
            //     //   params: {
            //     //     videoUrl: row.videoUrl
            //     //   }
            //     // }).then(res => {
            //     //   let SM3_PWD = res.data.list[0]
            //     //   console.log(res)
            //     //   console.log(res.data.list[0])
            //     let time = new Date().getTime()
            //     let superviseCode;
            //     let recDate;
            //     let nextTestDate;
            //     let reportNum;
            //     let userName;
            //     // let reportUrl;
            //     let unit;
            //     let unitArea;
            //     let liftType;
            //     let liftNum;
            //     let liftModel;
            //     let unitNum;
            //     let safety;
            //     let safetyNum;
            //     let areaName;
            //     let dcreateDate;
            //     let createUnit;
            //     let testedNum;
            //     if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
            //       superviseCode = "/"
            //     } else {
            //       superviseCode = row.superviseCode
            //     }
            //     if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
            //       recDate = " "
            //     } else {
            //       recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     }
            //     if (row.nextTestDate == null || row.nextTestDate == "" || row.nextTestDate == "/" || row.nextTestDate == undefined) {
            //       nextTestDate = " "
            //     } else {
            //       nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     }
            //     if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
            //       reportNum = "/"
            //     } else {
            //       reportNum = row.reportNum
            //     }
            //     if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
            //       userName = "/"
            //     } else {
            //       userName = row.userName
            //     }
            //     // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
            //     //   reportUrl = "/"
            //     // } else {
            //     //   reportUrl = row.reportUrl
            //     // }
            //     if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
            //       unit = "/"
            //     } else {
            //       unit = row.unit
            //     }
            //     if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
            //       unitArea = "/"
            //     } else {
            //       unitArea = row.unitArea
            //     }
            //     if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
            //       liftType = "/"
            //     } else {
            //       liftType = row.liftType
            //     }
            //     if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
            //       liftNum = "/"
            //     } else {
            //       liftNum = row.liftNum
            //     }
            //     if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
            //       liftModel = "/"
            //     } else {
            //       liftModel = row.liftModel
            //     }
            //     if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
            //       unitNum = "/"
            //     } else {
            //       unitNum = row.unitNum
            //     }
            //     if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
            //       safety = "/"
            //     } else {
            //       safety = row.safety
            //     }
            //     if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
            //       safetyNum = "1"
            //     } else {
            //       safetyNum = row.safetyNum
            //     }
            //     if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
            //       areaName = "/"
            //     } else {
            //       areaName = row.areaName
            //     }
            //     if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
            //       dcreateDate = "/"
            //     } else {
            //       dcreateDate = row.dcreateDate
            //     }
            //     if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
            //       createUnit = "/"
            //     } else {
            //       createUnit = row.createUnit
            //     }
            //     if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
            //       testedNum = "1"
            //     } else {
            //       testedNum = row.testedNum
            //     }
            //     row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
            //     request.get('/Record/UploadUpdate', {
            //       params:{
            //         recId: row.recId,
            //         time: time,
            //         String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
            //         String2: "{\n" +
            //             "    \"OIDNO\":\"" + superviseCode + "\",\n" +
            //             "    \"ISP_DATE\":\"" + recDate + "\",\n" +
            //             "    \"NEXT_ISP_DATE\":\"" + nextTestDate + "\",\n" +
            //             "    \"ISP_ISPCOD\":\"" + reportNum + "\",\n" +
            //             "    \"ISP_CONCLU\":\"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
            //             "    \"ISP_TYPE_COD\":\"50\",\n" +
            //             "    \"ISP_MEN\":\"" + userName + "\",\n" +
            //             "    \"NOTIFI_COD\":\"/\",\n" +
            //             "    \"REP_QUERY_ADDR\":\"" + row.reportUrl + "\",\n" +
            //             "    \"USE_UNT_NAME\":\"" + unit + "\",\n" +
            //             "    \"USE_UNT_ADDR\":\"" + unitArea + "\",\n" +
            //             "    \"EQP_NAME\":\"" + liftType + "\",\n" +
            //             "    \"FACTORY_COD\":\"" + liftNum + "\",\n" +
            //             "    \"EQP_MOD\":\"" + liftModel + "\",\n" +
            //             "    \"EQP_INNER_COD\":\"" + unitNum + "\",\n" +
            //             "    \"USE_LKMEN\":\"" + safety + "\",\n" +
            //             "    \"LKMAN_PHONE\":" + safetyNum + ",\n" +
            //             "    \"EQP_USE_ADDR\":\"" + areaName + "\",\n" +
            //             "    \"MAKE_DATE\":\"" + dcreateDate + "\",\n" +
            //             "    \"MAKE_UNT_NAME\":\"" + createUnit + "\",\n" +
            //             "    \"MANT_PHONE \":" + testedNum + ",\n" +
            //             "    \"SAFE_MEN\":\"" + safety + "\",\n" +
            //             "    \"SAFE_MEN_PHONE\":" + safetyNum + ",\n" +
            //             // "    \"SAFE_MEN_PHONE\":18080808080,\n" +
            //             "    \"VIDEO_URL\":\"" + row.videoUrl + "\",\n" +
            //             // "    \"SM3_PWD\":\"" + SM3_PWD + "\"\n" +
            //             "    \"SM3_PWD\":\"/\"\n" +
            //             "}"
            //       }
            //     }).then(res => {
            //           console.log(res)
            //           console.log(res[0])
            //           if (res.data.list[0] == "true") {
            //             this.$message({
            //               type: 'success',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //             this.ticket = []
            //             request.get('/Record/TrueUploadUpdate', {
            //               params: {
            //                 recId: row.recId
            //               }
            //             })
            //             this.load()
            //           } else if (res.data.list[0] == "false") {
            //             this.$message({
            //               type: 'error',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //           }
            //         }
            //     )
            //     // })
            //   }
            //
            // }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      } else if (this.RecordFlag == 4) {
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认上传检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            // if (row.recStatus == 0 || row.recStatus == 1) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   submitNum: row.submitNum + 1
            //   // }
            //   if (row.plaitDate == null || row.plaitDate == "") {
            //     request.get('/Record/WeaveUpdate', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       this.ticket = [];
            //       this.load()
            //       // this.tableData = []
            //       // this.total = 0
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //
            //         console.log(res)
            //       }
            //     })
            //   }
            //   else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   submitNum: row.submitNum + 1,
            //     //   plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
            //     request.get('/Record/WeaveUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1,
            //         plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm()
            //       // this.tableData = []
            //       // this.total = 0
            //       this.load()
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //         console.log(res)
            //         console.log(res.plaitHistory)
            //       }
            //     })
            //     // }
            //   }
            // }
            // if (row.recStatus == 5) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   auditNum: row.auditNum + 1
            //   // }
            //   if (row.processDate == null || row.processDate == "") {
            //     request.get('/Record/AuditUpdate', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1
            //       }
            //     }).then(res => {
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   } else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   auditNum: row.auditNum + 1,
            //     //   processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     request.get('/Record/AuditUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         auditNum: row.auditNum + 1,
            //         processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       if (res === 0) { //已审核，直接刷新
            //         this.$message({
            //           type: 'success',
            //           message: '数据已操作!'
            //         });
            //         this.ticket = []
            //         this.load()
            //       }
            //       if (res > 0) {
            //         console.log("审核结果");
            //         this.tocreatReport(row, 1); //重新生成报告
            //       }
            //       if (res < 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '审核失败!'
            //         });
            //       }
            //     })
            //   }
            // }
            // if (row.recStatus == 2) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   ratifyNum: row.ratifyNum + 1
            //   // }
            //   request.get('/Record/ApproveUpdate', {
            //     params:{
            //       recId: row.recId,
            //       ratifyNum: row.ratifyNum + 1
            //     }
            //   }).then(res => {
            //     // this.submitForm(this.formchecked, this.ThisForm)
            //     if (res === 0) { //已批准，直接刷新
            //       this.$message({
            //         type: 'success',
            //         message: '数据已操作!'
            //       });
            //       this.ticket = [];
            //       this.load();
            //     }
            //     if (res > 0) {
            //       this.tocreatReport(row, 2); //重新生成报告
            //     }
            //     if (res <0) {
            //       this.$message({
            //         type: 'error',
            //         message: '批准失败!'
            //       });
            //     }
            //     // this.ticket = []
            //     // this.load()
            //     // if (res > 0) {
            //     //   this.$message({
            //     //     type: 'success',
            //     //     message: '批准成功!'
            //     //   });
            //     // }
            //   })
            // }
            if (row.recStatus == 3) {
              // console.log(row)
              console.log(row.liftId)
              console.log(row.reportUrl)
              console.log(row.videoUrl)
              if (row.videoUrl == null) {
                // this.$message({
                //   type: 'error',
                //   message: '该条数据暂无检测视频,上传失败!'
                // });
                this.$confirm('该条数据暂无检测视频,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              } else if (row.stampReportUrl == null) {
                // this.$message({
                //   type: 'error',
                //   message: '该条数据暂无盖章检测报告,上传失败!'
                // });
                this.$confirm('该条数据暂无盖章检测报告,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              } else {
                request.get('/Record/getSM3_PWD', {
                  params: {
                    videoUrl: row.videoUrl
                  }
                }).then(res => {
                  let SM3_PWD = res.data.list[0]
                  console.log(res)
                  console.log(res.data.list[0])
                  let time = new Date().getTime()
                  let superviseCode;
                  let recDate;
                  // let nextDate;
                  let reportNum;
                  // let userName;
                  // let reportUrl;
                  let unit;
                  let unitArea;
                  let liftType;
                  let liftNum;
                  let liftModel;
                  let unitNum;
                  let safety;
                  let safetyNum;
                  let areaName;
                  let dcreateDate;
                  let createUnit;
                  let testedNum;
                  let userAlias;
                  if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
                    superviseCode = ""
                  } else {
                    superviseCode = row.superviseCode
                  }
                  if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
                    recDate = " "
                  } else {
                    recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
                  }
                  // if (row.nextDate == null || row.nextDate == "" || row.nextDate == "/" || row.nextDate == undefined) {
                  //   nextDate = " "
                  // } else {
                  //   // nextDate = this.formatDate(row.nextDate, "yyyy-MM-dd")
                  //   nextDate = " "
                  // }
                  if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
                    reportNum = ""
                  } else {
                    if (id == 0) {
                      reportNum = row.reportNum + "(改)"
                    } else if(id == 1) {
                      reportNum = row.reportNum + "（改1）"
                    }
                  }
                  // if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
                  //   userName = ""
                  // } else {
                  //   userName = row.userName
                  // }
                  if (row.userAlias == null || row.userAlias == "" || row.userAlias == "/" || row.userAlias == undefined) {
                    userAlias = ""
                  } else {
                    userAlias = row.userAlias
                  }
                  // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
                  //   reportUrl = "/"
                  // } else {
                  //   reportUrl = row.reportUrl
                  // }
                  if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
                    unit = ""
                  } else {
                    unit = row.unit
                  }
                  if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
                    unitArea = ""
                  } else {
                    unitArea = row.unitArea
                  }
                  if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
                    liftType = ""
                  } else {
                    liftType = row.liftType
                  }
                  if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
                    liftNum = ""
                  } else {
                    liftNum = row.liftNum
                  }
                  if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
                    liftModel = ""
                  } else {
                    liftModel = row.liftModel
                  }
                  if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
                    unitNum = ""
                  } else {
                    unitNum = row.unitNum
                  }
                  if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
                    safety = ""
                  } else {
                    safety = row.safety
                  }
                  if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
                    safetyNum = "1"
                  } else {
                    safetyNum = row.safetyNum
                  }
                  if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
                    areaName = ""
                  } else {
                    areaName = row.areaName
                  }
                  if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
                    dcreateDate = ""
                  } else {
                    dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")

                  }
                  if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
                    createUnit = ""
                  } else {
                    createUnit = row.createUnit
                  }
                  if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
                    testedNum = "1"
                  } else {
                    testedNum = row.testedNum
                  }
                  row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
                  row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
                  row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
                  request.get('/Record/UploadUpdate', {
                    params:{
                      recId: row.recId,
                      time: time,
                      String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
                      String2:"{\n" +
                          "    \"OIDNO\":\""+superviseCode+"\",\n" +
                          "    \"ISP_DATE\":\""+recDate+"\",\n" +
                          "    \"NEXT_ISP_DATE\":\" \",\n" +
                          "    \"ISP_ISPCOD\":\""+reportNum+"\",\n" +
                          "    \"ISP_CONCLU\": \"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
                          "    \"ISP_TYPE_COD\":\"50\",\n" +
                          "    \"ISP_MEN\":\""+userAlias+"\",\n" +
                          "    \"NOTIFI_COD\":\"\",\n" +
                          "    \"REP_QUERY_ADDR\":\""+row.stampReportUrl+"\",\n" +
                          "    \"ISP_PWD\":\"\",\n" +
                          "    \"USE_UNT_NAME\":\""+unit+"\",\n" +
                          "    \"USE_UNT_ADDR\":\""+unitArea+"\",\n" +
                          "    \"EQP_NAME\":\""+liftType+"\",\n" +
                          "    \"FACTORY_COD\":\""+liftNum+"\",\n" +
                          "    \"EQP_MOD\":\""+liftModel+"\",\n" +
                          "    \"EQP_INNER_COD\":\""+unitNum+"\",\n" +
                          "    \"USE_LKMEN\":\"" + safety + "\",\n" +
                          "    \"LKMAN_PHONE\":\""+safetyNum+"\",\n" +
                          "    \"EQP_USE_ADDR\":\""+areaName+"\",\n" +
                          "    \"MAKE_DATE\":\""+dcreateDate+"\",\n" +
                          "    \"MAKE_UNT_NAME\":\""+createUnit+"\",\n" +
                          "    \"MANT_PHONE \":\""+testedNum+"\",\n" +
                          "    \"SAFE_MEN\":\"" + safety + "\",\n" +
                          "    \"SAFE_MEN_PHONE\":\""+safetyNum+"\",\n" +
                          "    \"VIDEO_URL\":\""+row.videoUrl+"\",\n" +
                          "    \"SM3_PWD\":\""+SM3_PWD+"\",\n" +
                          "    \"ORIGINAL_RECORDS_URL\":\"\",\n" +
                          "    \"ORIGINAL_RECORDS_PWD\":\"\",\n" +
                          "    \"MEMORANDUM_URL\":\"\",\n" +
                          "    \"MEMORANDUM_PWD\":\"\",\n" +
                          "    \"NOT_ELIGIBLE_ITEMS\":[]\n" +
                          "}"
                    }
                  }).then(res => {
                    console.log(res)
                    console.log(res[0])
                    if (res.data.list[0] == "true") {
                      this.$confirm(res.data.list[1], '报告上传提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '关闭',
                        type: 'success',
                        closeOnClickModal: false
                      }).then(() => {
                        this.ticket = []
                        request.get('/Record/TrueUploadUpdate', {
                          params: {
                            recId: row.recId
                          }
                        })
                        this.load()
                      }).catch(() => {
                        this.ticket = []
                        request.get('/Record/TrueUploadUpdate', {
                          params: {
                            recId: row.recId
                          }
                        })
                        this.load()
                      });
                    } else if (res.data.list[0] == "false") {
                      this.$confirm(res.data.list[1], '报告上传提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '关闭',
                        type: 'warning',
                        closeOnClickModal: false
                      }).then(() => {
                      }).catch(() => {
                      });
                    } else if (res.data.list[3] === 0) {
                      this.$confirm(res.data.list[2], '报告上传提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '关闭',
                        type: 'warning',
                        closeOnClickModal: false
                      }).then(() => {
                      }).catch(() => {
                      });
                    }
                  })
                })
              }

            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      } else if (this.RecordFlag == 5) {
        let  name = sessionStorage.getItem("userName");
         if(name==null||name ==""||name ==undefined){
           this.$message({
             type: 'warning',
             message: '登录超时请重新登录!'
           });
           this.$router.push({path: '/login', query: {}});
           return;
         }

        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认审核检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            // if (row.recStatus == 0 || row.recStatus == 1) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   submitNum: row.submitNum + 1
            //   // }
            //   if (row.plaitDate == null || row.plaitDate == "") {
            //     request.get('/Record/WeaveUpdate', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm(this.formchecked, this.ThisForm)
            //       this.ticket = [];
            //       this.load()
            //       // this.tableData = []
            //       // this.total = 0
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //
            //         console.log(res)
            //       }
            //     })
            //   }
            //   else {
            //     // let map2 = {
            //     //   recId: row.recId,
            //     //   submitNum: row.submitNum + 1,
            //     //   plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //     // }
            //     console.log(this.formatDate(row.plaitDate, "MM-dd hh:mm"))
            //     request.get('/Record/WeaveUpdate2', {
            //       params:{
            //         recId: row.recId,
            //         submitNum: row.submitNum + 1,
            //         plaitHistory: this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm:ss")
            //       }
            //     }).then(res => {
            //       console.log("she审核按钮："+res)
            //       // this.submitForm()
            //       // this.tableData = []
            //       // this.total = 0
            //       this.load()
            //       if (res > 0) {
            //         this.$message({
            //           type: 'success',
            //           message: '提交成功!'
            //         });
            //         console.log(res)
            //         console.log(res.plaitHistory)
            //       }
            //     })
            //     // }
            //   }
            // }
            if (row.recStatus == 5) {
              // let map = {
              //   recId: row.recId,
              //   auditNum: row.auditNum + 1
              // }
              if (row.processDate == null || row.processDate == "") {
                request.get('/Record/AuditUpdate', {
                  params:{
                    recId: row.recId,
                    auditNum: row.auditNum + 1
                  }
                }).then(res => {
                  // this.submitForm(this.formchecked, this.ThisForm)
                  if (res === 0) { //已审核，直接刷新
                    this.$message({
                      type: 'success',
                      message: '数据已操作!'
                    });
                    this.ticket = []
                    this.load()
                  }
                  if (res > 0) {
                    console.log("审核结果");
                    this.tocreatReport(row, 1); //重新生成报告
                  }
                  if (res < 0) {
                    this.$message({
                      type: 'success',
                      message: '审核失败!'
                    });
                  }
                })
              } else {

                request.get('/Record/AuditUpdate2', {
                  params:{
                    recId: row.recId,
                    auditNum: row.auditNum + 1,
                    processHistory: this.formatDate(row.processDate, "yyyy-MM-dd hh:mm:ss")
                  }
                }).then(res => {
                  console.log("she审核按钮："+res)
                  // this.submitForm(this.formchecked, this.ThisForm)
                  if (res === 0) { //已审核，直接刷新
                    this.$message({
                      type: 'success',
                      message: '数据已操作!'
                    });
                    this.ticket = []
                    this.load()
                  }
                  if (res > 0) {
                    console.log("审核结果");
                    this.tocreatReport(row, 1); //重新生成报告
                  }
                  if (res < 0) {
                    this.$message({
                      type: 'success',
                      message: '审核失败!'
                    });
                  }
                })
              }
            }
            // if (row.recStatus == 2) {
            //   // let map = {
            //   //   recId: row.recId,
            //   //   ratifyNum: row.ratifyNum + 1
            //   // }
            //   request.get('/Record/ApproveUpdate', {
            //     params:{
            //       recId: row.recId,
            //       ratifyNum: row.ratifyNum + 1
            //     }
            //   }).then(res => {
            //     // this.submitForm(this.formchecked, this.ThisForm)
            //     if (res === 0) { //已批准，直接刷新
            //       this.$message({
            //         type: 'success',
            //         message: '数据已操作!'
            //       });
            //       this.ticket = [];
            //       this.load();
            //     }
            //     if (res > 0) {
            //       this.tocreatReport(row, 2); //重新生成报告
            //     }
            //     if (res <0) {
            //       this.$message({
            //         type: 'error',
            //         message: '批准失败!'
            //       });
            //     }
            //     // this.ticket = []
            //     // this.load()
            //     // if (res > 0) {
            //     //   this.$message({
            //     //     type: 'success',
            //     //     message: '批准成功!'
            //     //   });
            //     // }
            //   })
            // }
            // if (row.recStatus == 3) {
            //   // console.log(row)
            //   console.log(row.liftId)
            //   console.log(row.reportUrl)
            //   console.log(row.videoUrl)
            //   if (row.videoUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测视频,上传失败!'
            //     });
            //   } else if (row.reportUrl == null) {
            //     this.$message({
            //       type: 'error',
            //       message: '该条数据无检测报告,上传失败!'
            //     });
            //   } else {
            //     // request.get('/Record/getSM3_PWD', {
            //     //   params: {
            //     //     videoUrl: row.videoUrl
            //     //   }
            //     // }).then(res => {
            //     //   let SM3_PWD = res.data.list[0]
            //     //   console.log(res)
            //     //   console.log(res.data.list[0])
            //     let time = new Date().getTime()
            //     let superviseCode;
            //     let recDate;
            //     let nextTestDate;
            //     let reportNum;
            //     let userName;
            //     // let reportUrl;
            //     let unit;
            //     let unitArea;
            //     let liftType;
            //     let liftNum;
            //     let liftModel;
            //     let unitNum;
            //     let safety;
            //     let safetyNum;
            //     let areaName;
            //     let dcreateDate;
            //     let createUnit;
            //     let testedNum;
            //     if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
            //       superviseCode = "/"
            //     } else {
            //       superviseCode = row.superviseCode
            //     }
            //     if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
            //       recDate = " "
            //     } else {
            //       recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     }
            //     if (row.nextTestDate == null || row.nextTestDate == "" || row.nextTestDate == "/" || row.nextTestDate == undefined) {
            //       nextTestDate = " "
            //     } else {
            //       nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     }
            //     if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
            //       reportNum = "/"
            //     } else {
            //       reportNum = row.reportNum
            //     }
            //     if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
            //       userName = "/"
            //     } else {
            //       userName = row.userName
            //     }
            //     // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
            //     //   reportUrl = "/"
            //     // } else {
            //     //   reportUrl = row.reportUrl
            //     // }
            //     if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
            //       unit = "/"
            //     } else {
            //       unit = row.unit
            //     }
            //     if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
            //       unitArea = "/"
            //     } else {
            //       unitArea = row.unitArea
            //     }
            //     if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
            //       liftType = "/"
            //     } else {
            //       liftType = row.liftType
            //     }
            //     if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
            //       liftNum = "/"
            //     } else {
            //       liftNum = row.liftNum
            //     }
            //     if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
            //       liftModel = "/"
            //     } else {
            //       liftModel = row.liftModel
            //     }
            //     if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
            //       unitNum = "/"
            //     } else {
            //       unitNum = row.unitNum
            //     }
            //     if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
            //       safety = "/"
            //     } else {
            //       safety = row.safety
            //     }
            //     if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
            //       safetyNum = "1"
            //     } else {
            //       safetyNum = row.safetyNum
            //     }
            //     if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
            //       areaName = "/"
            //     } else {
            //       areaName = row.areaName
            //     }
            //     if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
            //       dcreateDate = "/"
            //     } else {
            //       dcreateDate = row.dcreateDate
            //     }
            //     if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
            //       createUnit = "/"
            //     } else {
            //       createUnit = row.createUnit
            //     }
            //     if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
            //       testedNum = "1"
            //     } else {
            //       testedNum = row.testedNum
            //     }
            //     row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
            //     row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
            //     row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
            //     request.get('/Record/UploadUpdate', {
            //       params:{
            //         recId: row.recId,
            //         time: time,
            //         String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
            //         String2: "{\n" +
            //             "    \"OIDNO\":\"" + superviseCode + "\",\n" +
            //             "    \"ISP_DATE\":\"" + recDate + "\",\n" +
            //             "    \"NEXT_ISP_DATE\":\"" + nextTestDate + "\",\n" +
            //             "    \"ISP_ISPCOD\":\"" + reportNum + "\",\n" +
            //             "    \"ISP_CONCLU\":\"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
            //             "    \"ISP_TYPE_COD\":\"50\",\n" +
            //             "    \"ISP_MEN\":\"" + userName + "\",\n" +
            //             "    \"NOTIFI_COD\":\"/\",\n" +
            //             "    \"REP_QUERY_ADDR\":\"" + row.reportUrl + "\",\n" +
            //             "    \"USE_UNT_NAME\":\"" + unit + "\",\n" +
            //             "    \"USE_UNT_ADDR\":\"" + unitArea + "\",\n" +
            //             "    \"EQP_NAME\":\"" + liftType + "\",\n" +
            //             "    \"FACTORY_COD\":\"" + liftNum + "\",\n" +
            //             "    \"EQP_MOD\":\"" + liftModel + "\",\n" +
            //             "    \"EQP_INNER_COD\":\"" + unitNum + "\",\n" +
            //             "    \"USE_LKMEN\":\"" + safety + "\",\n" +
            //             "    \"LKMAN_PHONE\":" + safetyNum + ",\n" +
            //             "    \"EQP_USE_ADDR\":\"" + areaName + "\",\n" +
            //             "    \"MAKE_DATE\":\"" + dcreateDate + "\",\n" +
            //             "    \"MAKE_UNT_NAME\":\"" + createUnit + "\",\n" +
            //             "    \"MANT_PHONE \":" + testedNum + ",\n" +
            //             "    \"SAFE_MEN\":\"" + safety + "\",\n" +
            //             "    \"SAFE_MEN_PHONE\":" + safetyNum + ",\n" +
            //             // "    \"SAFE_MEN_PHONE\":18080808080,\n" +
            //             "    \"VIDEO_URL\":\"" + row.videoUrl + "\",\n" +
            //             // "    \"SM3_PWD\":\"" + SM3_PWD + "\"\n" +
            //             "    \"SM3_PWD\":\"/\"\n" +
            //             "}"
            //       }
            //     }).then(res => {
            //           console.log(res)
            //           console.log(res[0])
            //           if (res.data.list[0] == "true") {
            //             this.$message({
            //               type: 'success',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //             this.ticket = []
            //             request.get('/Record/TrueUploadUpdate', {
            //               params: {
            //                 recId: row.recId
            //               }
            //             })
            //             this.load()
            //           } else if (res.data.list[0] == "false") {
            //             this.$message({
            //               type: 'error',
            //               message: res.data.list[1],
            //               duration:0,
            //               showClose: true
            //             });
            //           }
            //         }
            //     )
            //     // })
            //   }
            //
            // }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      }
    },

    //新规上传报告
    Audit3(row) {
      if (row.recStatus == 0 && row.recResult == 1){
        this.$confirm('该条记录还未进行重新编辑！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
        }).then(() => {
          this.$message({
            type: 'info',
            message: '请前往APP端进行重新编辑'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '请前往APP端进行重新编辑'
          });
        });
        return;
      }
      let tip = '是否确认审核检测记录?'
      if (this.RecordFlag == 4) {
        if (row.areaId == null || row.areaId == "") {
          this.$message({
            type: 'warning',
            message: '请先选择一条记录!'
          });
        } else {
          tip = '是否确认上传检测记录?'
          this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.disabledQualified = true
            if (row.recStatus == 3) {
              console.log(row.liftId)
              console.log(row.reportUrl)
              console.log(row.videoUrl)
              if (row.videoUrl == null) {
                // this.$message({
                //   type: 'error',
                //   message: '该条数据暂无检测视频,上传失败!'
                // });
                this.$confirm('该条数据暂无检测视频,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              } else if (row.stampReportUrl == null) {
                this.$confirm('该条数据暂无盖章检测报告,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              } else if (row.recordUrl == null) {
                this.$confirm('该条数据暂无原始记录,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              } else if (row.stampRecordUrl == null) {
                this.$confirm('该条数据暂无备忘录,上传失败!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                  closeOnClickModal: false
                }).then(() => {
                }).catch(() => {
                });
              } else {
                request.get('/Record/newGetSM3_PWD', {
                  params: {
                    stampReportUrl: row.stampReportUrl,
                    videoUrl: row.videoUrl,
                    recordUrl: row.recordUrl,
                    stampRecordUrl: row.stampRecordUrl
                  }
                }).then(res => {
                  let ISP_PWD = res.data.list[0];
                  let SM3_PWD = res.data.list[1];
                  let ORIGINAL_RECORDS_PWD = res.data.list[2];
                  let MEMORANDUM_PWD = res.data.list[3];
                  console.log(res)
                  console.log(res.data.list[0])
                  let time = new Date().getTime()
                  let superviseCode;
                  let recDate;
                  // let nextDate;
                  let reportNum;
                  // let userName;
                  // let reportUrl;
                  let unit;
                  let unitArea;
                  let liftType;
                  let liftNum;
                  let liftModel;
                  let unitNum;
                  let safety;
                  let safetyNum;
                  let areaName;
                  let dcreateDate;
                  let createUnit;
                  let testedNum;
                  let userAlias;
                  if (row.superviseCode == null || row.superviseCode == "" || row.superviseCode == "/" || row.superviseCode == undefined) {
                    superviseCode = ""
                  } else {
                    superviseCode = row.superviseCode
                  }
                  if (row.recDate == null || row.recDate == "" || row.recDate == "/" || row.recDate == undefined) {
                    recDate = " "
                  } else {
                    recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
                  }
                  // if (row.nextDate == null || row.nextDate == "" || row.nextDate == "/" || row.nextDate == undefined) {
                  //   nextDate = " "
                  // } else {
                  //   // nextDate = this.formatDate(row.nextDate, "yyyy-MM-dd")
                  //   nextDate = " "
                  // }
                  if (row.reportNum == null || row.reportNum == "" || row.reportNum == "/" || row.reportNum == undefined) {
                    reportNum = ""
                  } else {
                    reportNum = row.reportNum.trim()
                  }
                  // if (row.userName == null || row.userName == "" || row.userName == "/" || row.userName == undefined) {
                  //   userName = ""
                  // } else {
                  //   userName = row.userName
                  // }
                  if (row.userAlias == null || row.userAlias == "" || row.userAlias == "/" || row.userAlias == undefined) {
                    userAlias = ""
                  } else {
                    userAlias = row.userAlias
                  }
                  // if (row.reportUrl == null || row.reportUrl == "" || row.reportUrl == "/") {
                  //   reportUrl = "/"
                  // } else {
                  //   reportUrl = row.reportUrl
                  // }
                  if (row.unit == null || row.unit == "" || row.unit == "/" || row.unit == undefined) {
                    unit = ""
                  } else {
                    unit = row.unit
                  }
                  if (row.unitArea == null || row.unitArea == "" || row.unitArea == "/" || row.unitArea == undefined) {
                    unitArea = ""
                  } else {
                    unitArea = row.unitArea
                  }
                  if (row.liftType == null || row.liftType == "" || row.liftType == "/" || row.liftType == undefined) {
                    liftType = ""
                  } else {
                    liftType = row.liftType
                  }
                  if (row.liftNum == null || row.liftNum == "" || row.liftNum == "/" || row.liftNum == undefined) {
                    liftNum = ""
                  } else {
                    liftNum = row.liftNum
                  }
                  if (row.liftModel == null || row.liftModel == "" || row.liftModel == "/" || row.liftModel == undefined) {
                    liftModel = ""
                  } else {
                    liftModel = row.liftModel
                  }
                  if (row.unitNum == null || row.unitNum == "" || row.unitNum == "/" || row.unitNum == undefined) {
                    unitNum = ""
                  } else {
                    unitNum = row.unitNum
                  }
                  if (row.safety == null || row.safety == "" || row.safety == "/" || row.safety == undefined) {
                    safety = ""
                  } else {
                    safety = row.safety
                  }
                  if (row.safetyNum == null || row.safetyNum == "" || row.safetyNum == "/" || row.safetyNum == undefined) {
                    safetyNum = "1"
                  } else {
                    safetyNum = row.safetyNum
                  }
                  if (row.areaName == null || row.areaName == "" || row.areaName == "/" || row.areaName == undefined) {
                    areaName = ""
                  } else {
                    areaName = row.areaName
                  }
                  if (row.dcreateDate == null || row.dcreateDate == "" || row.dcreateDate == "/" || row.dcreateDate == undefined) {
                    dcreateDate = ""
                  } else {
                    dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")

                  }
                  if (row.createUnit == null || row.createUnit == "" || row.createUnit == "/" || row.createUnit == undefined) {
                    createUnit = ""
                  } else {
                    createUnit = row.createUnit
                  }
                  if (row.testedNum == null || row.testedNum == "" || row.testedNum == "/" || row.testedNum == undefined) {
                    testedNum = "1"
                  } else {
                    testedNum = row.testedNum
                  }
                  row.recDate = this.formatDate(row.recDate, "yyyy-MM-dd")
                  row.nextTestDate = this.formatDate(row.nextTestDate, "yyyy-MM-dd")
                  row.dcreateDate = this.formatDate(row.dcreateDate, "yyyy-MM-dd")
                  request.get('/Record/UploadUpdate', {
                    params:{
                      recId: row.recId,
                      time: time,
                      String1: "{\n" + "\t\"USE_UNT_NAME\":\"" + unit + "\",\n" + "\t\"USE_UNT_COD\" :\"" + row.unitCode + "\",\n" + "\t\"OIDNO\": \"" + superviseCode + "\"\n" + "}",
                      String2:"{\n" +
                          "    \"OIDNO\":\""+superviseCode+"\",\n" +
                          "    \"ISP_DATE\":\""+recDate+"\",\n" +
                          "    \"NEXT_ISP_DATE\":\" \",\n" +
                          "    \"ISP_ISPCOD\":\""+reportNum+"\",\n" +
                          "    \"ISP_CONCLU\": \"所检测项目均符合《电梯自行检测规则》(TSG T7008-2023)的相应要求\",\n" +
                          "    \"ISP_TYPE_COD\":\"50\",\n" +
                          "    \"ISP_MEN\":\""+userAlias+"\",\n" +
                          "    \"NOTIFI_COD\":\"\",\n" +
                          "    \"REP_QUERY_ADDR\":\""+row.stampReportUrl+"\",\n" +
                          "    \"ISP_PWD\":\""+ISP_PWD+"\",\n" +
                          "    \"USE_UNT_NAME\":\""+unit+"\",\n" +
                          "    \"USE_UNT_ADDR\":\""+unitArea+"\",\n" +
                          "    \"EQP_NAME\":\""+liftType+"\",\n" +
                          "    \"FACTORY_COD\":\""+liftNum+"\",\n" +
                          "    \"EQP_MOD\":\""+liftModel+"\",\n" +
                          "    \"EQP_INNER_COD\":\""+unitNum+"\",\n" +
                          "    \"USE_LKMEN\":\"" + safety + "\",\n" +
                          "    \"LKMAN_PHONE\":\""+safetyNum+"\",\n" +
                          "    \"EQP_USE_ADDR\":\""+areaName+"\",\n" +
                          "    \"MAKE_DATE\":\""+dcreateDate+"\",\n" +
                          "    \"MAKE_UNT_NAME\":\""+createUnit+"\",\n" +
                          "    \"MANT_PHONE \":\""+testedNum+"\",\n" +
                          "    \"SAFE_MEN\":\"" + safety + "\",\n" +
                          "    \"SAFE_MEN_PHONE\":\""+safetyNum+"\",\n" +
                          "    \"VIDEO_URL\":\""+row.videoUrl+"\",\n" +
                          "    \"SM3_PWD\":\""+SM3_PWD+"\",\n" +
                          "    \"ORIGINAL_RECORDS_URL\":\""+row.recordUrl+"\",\n" +
                          "    \"ORIGINAL_RECORDS_PWD\":\""+ORIGINAL_RECORDS_PWD+"\",\n" +
                          "    \"MEMORANDUM_URL\":\""+row.stampRecordUrl+"\",\n" +
                          "    \"MEMORANDUM_PWD\":\""+MEMORANDUM_PWD+"\",\n" +
                          "    \"NOT_ELIGIBLE_ITEMS\":[]\n" +
                          "}"
                    }
                  }).then(res => {
                    console.log(res)
                    console.log(res[0])
                    if (res.data.list[0] == "true") {
                      this.$confirm(res.data.list[1], '报告上传提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '关闭',
                        type: 'success',
                        closeOnClickModal: false
                      }).then(() => {
                        this.ticket = []
                        request.get('/Record/TrueUploadUpdate', {
                          params: {
                            recId: row.recId
                          }
                        })
                        this.load()
                      }).catch(() => {
                        this.ticket = []
                        request.get('/Record/TrueUploadUpdate', {
                          params: {
                            recId: row.recId
                          }
                        })
                        this.load()
                      });
                    } else if (res.data.list[0] == "false") {
                      this.$confirm(res.data.list[1], '报告上传提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '关闭',
                        type: 'warning',
                        closeOnClickModal: false
                      }).then(() => {
                      }).catch(() => {
                      });
                    } else if (res.data.list[3] === 0) {
                      this.$confirm(res.data.list[2], '报告上传提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '关闭',
                        type: 'warning',
                        closeOnClickModal: false
                      }).then(() => {
                      }).catch(() => {
                      });
                    }
                  })
                })
              }
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }
      }
    },

    //驳回按钮
    Qualified(row) {
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        this.dialogResultVisible = true
        console.log(row)
        console.log(row.backStatus)
        this.formResult.recId = row.recId
        if(this.RecordFlag == 5) {
          this.formResult.backStatus = row.backStatus
        }
        else if (this.RecordFlag == 2) {
          this.formResult.ratifyBack = row.ratifyBack
        }
        this.formResult.rejectDetail = ''
        if (row.backData != null || row.backData != "") {
          let bhsj = this.formatDate(row.backData, "MM-dd hh:mm")
          sessionStorage.setItem("bhsj", bhsj)
        }
      }
    },
    //获取用户权限
    getList(){
      this.authList = [];
      let user = sessionStorage.getItem('authorityId'); //1,2,3
      console.log(user)
      console.log(typeof user)
      if(user.length > 1){
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.authList = user.split(",");
      } else if (user.length === 1){
        this.authList = user
        console.log(user.authorityId)
      }
    },
    //给报告和记录盖上电子印章
    ToSeal(row){
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        console.log(this.authList)
        if (this.authList.indexOf('17') !== -1) {
          let sealreportUrl = '';//盖章的报告
          // let sealrecordUrl = '';//盖章的记录
          let map = {
            recId: row.recId,
          }
          request.post('/detection/sealreport', map).then(res => {

            console.log(res)
            if (res.code === "0") {
              sealreportUrl = res.data.stampReportUrl;
              window.open(sealreportUrl);
              // window.open(sealrecordUrl);
              this.ticket = [];
              this.load()
              // request.post('/detection/sealRecord', map).then(res => {
              //   console.log(res)
              //   if(res.code==="0"){
              //     // sealrecordUrl =res.data.stampRecordUrl;
              //     window.open(sealreportUrl);
              //     // window.open(sealrecordUrl);
              //     this.ticket = [];
              //     this.load()
              //   }else {
              //     this.$message({
              //       message: '生成盖章的原始记录失败！',
              //       type: 'error'
              //     });
              //   }
              // })
            }else {
              this.$message({
                message: '生成盖章的报告失败！',
                type: 'error'
              });
            }
          })
        } else {

          this.$message({
            message: '无盖章权限！',
            type: 'error'
          });
        }
      }
    },
    //记录查询
    ReportQuery(row){
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        console.log("记录生成")
        // let map = {
        //   recId: row.recId
        // }
        this.$confirm('是否确定打开?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // request.post('/detection/reportquery', map).then(res => {
          //   console.log("打开报告详情")
          console.log(row)
          // this.$router.push({path:'RecordPdf', query:{recordpdf:res.filepath}})
          // if (this.authList.indexOf('17') !== -1) {
          //   if (row.stampRecordUrl == null || row.stampRecordUrl == "") {
          //     this.$message({
          //       type: 'error',
          //       message: '该记录暂无盖章原始记录!'
          //     });
          //     if (row.recordUrl == null || row.recordUrl == "") {
          //       this.$message({
          //         type: 'error',
          //         message: '该记录暂无原始记录!'
          //       });
          //     } else {
          //       window.open(row.recordUrl);
          //     }
          //   } else {
          //     window.open(row.stampRecordUrl);
          //   }
          //
          // }else {
          if (row.recordUrl == null || row.recordUrl == "") {
            this.$message({
              type: 'error',
              message: '该记录暂无原始记录!'
            });
          } else {
            window.open(row.recordUrl);
          }
          // }
          // window.open(res.data.recordUrl);
          // })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },

    //报告详情
    ReportDetails(row){
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        console.log("报告生成")
        // let map = {
        //   recId: row.recId
        // }
        this.$confirm('是否确定打开?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // request.post('/detection/report', map).then(res => {
          //   console.log("记录查询")
          console.log(row)
          //   // console.log(res.data.filepath)
          //   // this.$router.push({path:'RecordPdf', query:{recordpdf:res.filepath}})
          if (this.authList.indexOf('20') !== -1 && (row.recStatus==3|| row.recStatus==4)) {
            if (row.stampReportUrl == null || row.stampReportUrl == "") {
              this.$message({
                type: 'error',
                message: '该记录暂无盖章报告!'
              });
              if (row.reportUrl == null || row.reportUrl == "") {
                this.$message({
                  type: 'error',
                  message: '该记录暂无报告!'
                });
              } else {
                window.open(row.reportUrl);
              }
            } else {
              window.open(row.stampReportUrl);
            }
          }else {
            if (row.reportUrl == null || row.reportUrl == "") {
              this.$message({
                type: 'error',
                message: '该记录暂无报告!'
              });
            } else {
              window.open(row.reportUrl);
            }
          }
          //   window.open(res.data.reportUrl);
          // })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },

    //备忘录
    NoticeQuery(row){
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        console.log("备忘录生成")
        // let map = {
        //   recId: row.recId
        // }
        this.$confirm('是否确定打开?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // request.post('/detection/report', map).then(res => {
          //   console.log("记录查询")
          console.log(row)
          //   // console.log(res.data.filepath)
          //   // this.$router.push({path:'RecordPdf', query:{recordpdf:res.filepath}})
          if (this.authList.indexOf('20') !== -1 && (row.recStatus==3|| row.recStatus==4)) {
            if (row.stampRecordUrl == null || row.stampRecordUrl === "") {
              this.$message({
                type: 'error',
                message: '该记录暂无盖章备忘录!'
              });
              if (row.noticeUrl == null || row.noticeUrl === "") {
                this.$message({
                  type: 'error',
                  message: '该记录暂无备忘录!'
                });
              } else {
                window.open(row.noticeUrl);
              }
            } else {
              window.open(row.stampRecordUrl);
            }
          }else {
            if (row.noticeUrl == null || row.noticeUrl === "") {
              this.$message({
                type: 'error',
                message: '该记录暂无备忘录!'
              });
            } else {
              window.open(row.noticeUrl);
            }
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },

    // 检测视频
    VideoQuery(row){
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        console.log("检测视频生成")
        // let map = {
        //   recId: row.recId
        // }
        this.$confirm('是否确定打开?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // request.post('/detection/report', map).then(res => {
          //   console.log("记录查询")
          console.log(row)
          //   // console.log(res.data.filepath)
          //   // this.$router.push({path:'RecordPdf', query:{recordpdf:res.filepath}})
          if (row.videoUrl == null || row.videoUrl == "") {
            this.$message({
              type: 'error',
              message: '该记录暂无检测视频!'
            });
          } else {
            window.open(row.videoUrl);
          }
          //   window.open(res.data.reportUrl);
          // })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },

    // 检测图片
    PictureQuery(row) {
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        console.log(row)
        this.urls = []
        request.get('/RecDetView/QueryPicture', {
          params: {
            recId: row.recId
          }
        }).then(res => {
          for (let i = 0; i < res.length; i++) {
            if (res[i].toString().split(",").length > 1) {
              for (let j = 0; j < res[i].toString().split(",").length; j++) {
                if (res[i].toString().split(",")[j] !== "无") {
                  this.urls.push(res[i].toString().split(",")[j])
                  console.log(this.urls)
                  console.log(this.urls.length)
                }
              }
            } else {
              if (res[i] !== "无") {
                this.urls.push(res[i])
                console.log(this.urls)
              }
            }
          }
          console.log(this.urls.length)
          if (this.urls.length !== 0) {
            this.tp = true
          } else {
            this.$message({
              type: 'warning',
              message: '此记录无检测图片！'
            })
            this.tp = false
          }
        })
        console.log(this.urls.length)
        console.log(this.urls)
      }
    },

    VideoUpload(row) {
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
      } else {
        this.tcts = true
        this.fileList.length = 0
        this.fileList = []
        console.log(row)
      }
    },

    showQuery() {
      this.cxtj = true
    },

    uploadAgain() {

    },

    // uploadSuccess(res,file) {
    uploadSuccess(res) {
      //   this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res)
      console.log(res.videoUrl)
      // console.log(row)
      console.log(res.data)
      console.log(typeof res.data)
      this.videoUploadUrl = res
      console.log(this.videoUploadUrl)
      this.fileList.length = 1
      // console.log(row.videoUrl)
      // res.videoUrl = res.data
      // console.log(row)
      // this.form.userSign = file.response.data
      // this.url = res.data

    },

    beforeAvatarUpload(file) {
      const isMP4 = file.type === 'video/mp4';
      // const isPNG = file.type === 'image/png';
      const isLt5120M = file.size / 1024 / 1024 < 10240;

      if (!isMP4) {
        this.$message.error('上传视频只能是 MP4 格式!');
      }
      // if (!isPNG) {
      //   this.$message.error('上传签名图片只能是 PNG 格式!');
      // }
      if (!isLt5120M) {
        this.$message.error('上传视频大小不能超过 10GB!');
      }
      // return (isJPG && isLt2M) || (isPNG && isLt2M);
      return isMP4 && isLt5120M;
    },
//  :on-progress="onProgressTest"
    onProgressTest (event, file, fileList) {
      // console.log(file)
      // console.log(fileList)
      let index = 0
      // 只有fileList 跟file 里面的uid是唯一的互相对应的
      fileList.forEach((v, i) => {
        // console.log(v)
        if (v.uid === file.uid) {
          index = i
        }
      })
      // 获取动态的进度
      let percent = parseInt(event.percent)
      this.$nextTick(() => {
        setTimeout(() => {
          if (percent >= 99) {
            // 当动态的进度超过99就获取dom 让值一直显示99直到上传成功
            let dom = document.getElementsByClassName('el-upload-list__item')[index]
            let progressText = dom.getElementsByClassName('el-progress__text')
            if (progressText && progressText.length) {
              progressText[0].style.opacity = 0
              progressText[0].innerText = '99%'
              progressText[0].style.opacity = 1
            }
          }
          return 22;
        })
      })

    },
    handlePreview(file) {
      console.log(file);
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList.length = 0
    },

    beforeRemove(file, fileList) {
      console.log(fileList)
      return this.$confirm(`确定移除 ${ file.name }？`);
    },

    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    handlePictureCardPreview(file) {
      console.log(file)
      console.log(file.response.data)
      // this.dialogImageUrl = file.url;
      this.dialogImageUrl = file.response.data;
      this.singVisible = true;
    },

    onSubmit(row) {
      if (this.fileList.length == 0) {
        this.$message({
          type: 'warning',
          message: '未选择视频文件!'
        })
      } else {
        console.log(row)
        console.log(this.videoUploadUrl)
        console.log(row.videoUrl)
        row.videoUrl = this.videoUploadUrl
        request.get('/Record/uploadVideo', {
          params: {
            recId: row.recId,
            videoUploadUrl: this.videoUploadUrl
          }
        })
        this.tcts = false
        this.$message({
          type: 'success',
          message: '上传视频成功!'
        })
      }
    },

    //驳回提交
    formResultSave(){
      if (this.RecordFlag == 5) {
        // eslint-disable-next-line no-undef
        if (this.formResult.rejectDetail == '' || this.formResult.rejectDetail == null){
          this.$alert('请输入退回原因', '提示', {
            confirmButtonText: '确定',

          });
          return;
        }
        request.get('/Record/ResultUpdate', {
          params:{
            recId: this.formResult.recId,
            rejectDetail: this.formResult.rejectDetail,
            recStatus: this.formResult.recStatus,
            nowRecStatus:this.RecordFlag
          }
        }).then(res => {
          console.log("驳回回调")
          console.log(res)
          if (res > 0) {
            this.dialogResultVisible = false
            this.tocreatReport(this.formResult, 3); //重新生成报告
          }
          if (res === 0) { //已驳回,直接刷新
            this.dialogResultVisible = false
            this.ticket = [];
            this.load()
            // this.submitForm(this.formchecked, this.ThisForm)
            this.$message({
              type: 'success',
              message: '数据已操作'
            });
          }
          if (res < 0) { //驳回失败
            this.dialogResultVisible = false
            this.$message({
              type: 'error',
              message: '退回失败'
            });
          }
        })
        console.log("驳回提交")
      } else if (this.RecordFlag == 2) {
        // eslint-disable-next-line no-undef
        if (this.formResult.rejectDetail == '' || this.formResult.rejectDetail == null){
          this.$alert('请输入退回原因', '提示', {
            confirmButtonText: '确定',
          });
          return;
        }

        request.get('/Record/ResultUpdate2', {
          params:{
            recId: this.formResult.recId,
            rejectDetail: this.formResult.rejectDetail,
            recStatus: this.formResult.recStatus,
            nowRecStatus:this.RecordFlag
          }
        }).then(res => {
          console.log("驳回回调")
          console.log(res)
          if (res > 0) {
            this.dialogResultVisible = false
            this.tocreatReport(this.formResult, 4); //重新生成报告
            // this.createRecord(this.formResult);//生成记录详情
          }
          if (res === 0) { //已驳回,直接刷新
            this.dialogResultVisible = false
            this.$message({
              type: 'success',
              message: '数据已操作'
            });
            this.ticket = [];
            this.load()
          }
          if (res < 0) { //驳回失败
            this.dialogResultVisible = false
            this.$message({
              type: 'error',
              message: '退回失败'
            });
          }
        })
        console.log("驳回提交")
      }
    },
    //退回到审核或批准提交
    formResultSave2(){
      if (this.RecordFlag == 4) {
        let  name = sessionStorage.getItem("userName");
        if(name==null||name ==""||name ==undefined){
          this.$message({
            type: 'warning',
            message: '登录超时请重新登录!'
          });
          this.$router.push({path: '/login', query: {}});
          return;
        }
        if(this.formResult.recStatus==0||this.formResult.recStatus==null || this.formResult.recStatus ==""){
          this.$message({
            type: 'warning',
            message: '请选择退回去向!'
          });
          return;
        }
        request.get('/Record/recStatusUpdate', {
          params:{
            recId: this.formResult.recId,
            // rejectDetail: this.formResult.rejectDetail,
            recStatus: this.formResult.recStatus,
            userName: localStorage.getItem("userName"),
            nowRecStatus:3//已批准的状态
          }
        }).then(res => {
          console.log("驳回回调")
          console.log(res)
          if (res > 0) {
            this.dialogResultVisible = false
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            // this.tocreatReport(this.formResult, 3); //重新生成报告
            this.ticket = [];
            this.load()
          }
          if (res === 0) { //已驳回,直接刷新
            this.dialogResultVisible = false
            this.ticket = [];
            this.load()
            // this.submitForm(this.formchecked, this.ThisForm)
            this.$message({
              type: 'success',
              message: '数据已操作'
            });
          }
          if (res < 0) { //驳回失败
            this.dialogResultVisible = false
            this.$message({
              type: 'error',
              message: '退回失败'
            });
          }
        })
        console.log("驳回提交")
      }
    },

    //页面初始化
    load(reload) {
      let  name = sessionStorage.getItem("userName");
      if(name==null||name ==""||name ==undefined){
        this.$message({
          type: 'warning',
          message: '登录超时请重新登录!'
        });
        this.$router.push({path: '/login', query: {}});
        return;
      }
      console.log(this.RecordFlag)
      if (this.reload === reload) {
        this.currentPage = 1;
      }
      if (this.RecordFlag == 0 || this.RecordFlag == 1) {
        request.get('/RecDetView/RecDetWeaveAll1', {
          params: {
            userName: sessionStorage.getItem("userName"),
            roleId:sessionStorage.getItem("roleId"),
            areaId:sessionStorage.getItem("areaId"),
            currentPage:this.currentPage,
            pageSize:this.pageSize,
            sign:"0"//用于标识是编制
          }
        }).then(res => {
          console.log(res);
          console.log(this.ticket)
          this.tep =0;
          this.tableData =[];
          this.tableData = res.data.list;
          this.total =res.data.total;
          // this.ticket =[];
          // this.ticket = res;
          // this.total = this.ticket.length
          this.loadang = false
          // this.getPageInfo()
        })
      }
      if (this.RecordFlag == 5) {
        //    RecDetViewAuditAll
        request.get('/RecDetView/RecDetWeaveAll2', {
          params: {
            userName: sessionStorage.getItem("userName"),
            roleId:sessionStorage.getItem("roleId"),
            areaId:sessionStorage.getItem("areaId"),
            currentPage:this.currentPage,
            pageSize:this.pageSize,
            sign:"5"//用于标识是审核
          }
        }).then(res => {
          console.log(res);
          console.log(this.ticket)
          this.tep =1;
          this.tableData =[];
          this.tableData = res.data.list;
          this.total =res.data.total;
          this.loadang = false
        })
      }
      if (this.RecordFlag == 2) {
        //RecDetApproveAll
        request.get('/RecDetView/RecDetWeaveAll2', {
          params: {
            userName: sessionStorage.getItem("userName"),
            roleId:sessionStorage.getItem("roleId"),
            areaId:sessionStorage.getItem("areaId"),
            currentPage:this.currentPage,
            pageSize:this.pageSize,
            sign:"2"//用于标识是批准
          }
        }).then(res => {
          console.log(res);
          this.tep =2;
          this.tableData =[];
          this.tableData = res.data.list;
          this.total =res.data.total;
          this.loadang = false
        })
      }
      if (this.RecordFlag == 3 ) {
        //RecDetQueryAndUploadAll
        request.get('/RecDetView/RecDetWeaveAll1', {
          params: {
            userName: sessionStorage.getItem("userName"),
            roleId:sessionStorage.getItem("roleId"),
            areaId:sessionStorage.getItem("areaId"),
            currentPage:this.currentPage,
            pageSize:this.pageSize,
            sign:"1"//用于标识是检测查询
          }
        }).then(res => {
          console.log(res);
          this.tep =4;
          this.tableData =[];
          this.tableData = res.data.list;
          this.total =res.data.total;
          this.loadang = false
        })
      }
      if (this.RecordFlag == 4) {
        //UploadAll
        request.get('/RecDetView/RecDetWeaveAll2', {
          params: {
            userName: sessionStorage.getItem("userName"),
            roleId:sessionStorage.getItem("roleId"),
            areaId:sessionStorage.getItem("areaId"),
            currentPage:this.currentPage,
            pageSize:this.pageSize,
            sign:"3"//用于标识是上传
          }
        }).then(res => {
          console.log(res);
          console.log(this.ticket)
          this.tep =4;
          this.tableData =[];
          this.tableData = res.data.list;
          this.total =res.data.total;
          // this.ticket = res;
          // this.total = this.ticket.length
          this.loadang = false
          // this.getPageInfo()
        })
      }
    },


    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return ""
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },

    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      switch (this.tep) {
        case 0:this.load(1);break;
        case 1:this.load(1);break;
        case 2:this.load(1);break;
        case 3:this.load(1);break;
        case 4:this.load(1);break;
        case 5:this.submitForm(1);break;
        case 6:this.submitForm(1);break;
        case 7:this.submitForm(1);break;
        case 8:this.submitForm(1);break;
      }
      //数据重新分页
      // this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      switch (this.tep) {
        case 0:this.load(1);break;
        case 1:this.load(1);break;
        case 2:this.load(1);break;
        case 3:this.load(1);break;
        case 4:this.load(1);break;
        case 5:this.submitForm(1);break;
        case 6:this.submitForm(1);break;
        case 7:this.submitForm(1);break;
        case 8:this.submitForm(1);break;
      }
      //数据重新分页
      // this.getPageInfo()
    },

    // tableRowClassName({rowIndex}) {
    //   for (var i = 0; i < this.tableData.length; i++) {
    //     if (rowIndex === i) {
    //       return 'success-row';
    //     }
    //
    //   }
    //   return '';
    // },
    showlc(row) {
      if (row.areaId == null || row.areaId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择一条记录!'
        });
        this.timeline = false
        this.timeline2 = false
        this.timeline3 = false
      } else {
        let map = {
          recId: row.recId
        }
        request.post('/RecDetView/RecDetQuery', map).then(res => {
          console.log(res)
          for (let i = 0; i < res.length; i++) {
            let dycsj = this.formatDate(row.plaitDate, "MM-dd hh:mm")
            sessionStorage.setItem("dycsj", dycsj)
            if ((this.RecordFlag == 0 && res[0].submitNum !== 0) || this.RecordFlag == 5) {
              for (let j = 0; j < this.items.length; j++) {
                res[0].plaitDate = this.formatDate(res[0].plaitDate, "MM-dd hh:mm")
                this.items[0].person = res[0].plaitBy
                this.items[0].time = res[0].plaitDate
                this.items[0].content = '编制中 -> 审核中'
              }
            }
            if (this.RecordFlag == 2 || (this.RecordFlag == 0 && res[0].auditNum !== 0) || (this.RecordFlag == 5 && res[0].auditNum !== 0 && res[0].submitNum == 1)) {
              for (let j = 0; j < this.items2.length; j++) {
                res[0].plaitDate = this.formatDate(res[0].plaitDate, "MM-dd hh:mm")
                res[0].processDate = this.formatDate(res[0].processDate, "MM-dd hh:mm")
                console.log(res[0].plaitBy)
                this.items2[1].person = res[0].plaitBy
                this.items2[1].time = res[0].plaitDate
                this.items2[1].content = '编制中 -> 审核中'
                this.items2[0].person = res[0].processBy
                this.items2[0].time = res[0].processDate
                this.items2[0].content = '审核中 -> 批准中'
              }
            }
            if (this.RecordFlag == 3) {
              for (let j = 0; j < this.items3.length; j++) {
                res[0].plaitDate = this.formatDate(res[0].plaitDate, "MM-dd hh:mm")
                res[0].processDate = this.formatDate(res[0].processDate, "MM-dd hh:mm")
                res[0].ratifyData = this.formatDate(res[0].ratifyData, "MM-dd hh:mm")
                this.items3[2].person = res[0].plaitBy
                // this.items4[2].time = res[0].plaitDate
                this.items3[2].time = res[0].plaitDate
                this.items3[2].content = '编制中 -> 审核中'
                this.items3[1].person = res[0].processBy
                this.items3[1].time = res[0].processDate
                this.items3[1].content = '审核中 -> 批准中'
                this.items3[0].person = res[0].ratifyBy
                this.items3[0].time = res[0].ratifyData
                this.items3[0].content = '批准中 -> 已批准'
              }
            }
          }
        })
        console.log(row);
        console.log(row.plaitDate)

        console.log(sessionStorage.getItem("sj"))
        console.log(this.formatDate(row.plaitDate, "yyyy-MM-dd hh:mm"))
        if (row.submitNum == 0) {
          this.$message({
            type: 'error',
            message: '该条记录暂时没有审批操作!'
          });
        }
        if ((this.RecordFlag == 0 && row.submitNum !== 0) || this.RecordFlag == 5) {
          this.timeline = true
        }
        if (this.RecordFlag == 2 || (this.RecordFlag == 0 && row.auditNum !== 0) || (this.RecordFlag == 5 && row.auditNum !== 0 && row.submitNum == 1)) {
          this.timeline2 = true
          this.timeline = false
        }
        if (this.RecordFlag == 3) {
          this.timeline3 = true
          this.timeline2 = false
          this.timeline = false
        }
        console.log(row.plaitBy)
        for (let i = 0; i < this.items.length; i++) {
          console.log(this.items[i].person)
          console.log(this.items[i].time)
        }
      }
    },
  },
  unmount() {
    clearTimeout(22);//清除上传进度条的延时器
  },
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
/*.el-table {*/
/*  width: 100%;*/
/*}*/
/*.el-table__header-wrapper table,*/
/*.el-table__body-wrapper table {*/
/*  width: 100% !important;*/
/*}*/

/*.el-table__body,*/
/*.el-table__footer,*/
/*.el-table__header {*/
/*  table-layout: auto;*/
/*}*/
.items{
  margin: 50px;
}
.item{
  font-size: 13px;
  color: #666;
  display: flex;
  align-content: center;
  position: relative;
  height: 86px;
}
.point{
  width:12px ;
  height: 12px;
  background: #00a5fe;
  border-radius: 50%;
}
.line{
  position: absolute;
  left: 5px;
  top: 12px;
  width: 2px;
  height: 75px;
  background: #00c3fe;
}
.item-right{
  margin-left: 14px;
  margin-top: -2px;
}
</style>